import _, { reject } from "lodash";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import shortid from "shortid";
import moment from "moment";
import { services_routing } from "../Utils/Constants";
import { resolve } from "promise";
import { GIF_UPLOAD, YOUTUBE_URL } from "../Constants/types";
import { getFileBase64, getFilePath } from "../Utils/utils";
import { DEFAULT_CRM_TABS } from "../screens/BespokeCRMTabs/constants";

async function deleteQueryBatch(db, query, resolve) {
  const snapshot = await query.get();

  const batchSize = snapshot.size;
  if (batchSize === 0) {
    // When there are no documents left, we are done
    resolve();
    return;
  }

  // Delete documents in a batch
  const batch = db.batch();
  snapshot.docs.forEach((doc) => {
    batch.delete(doc.ref);
  });
  await batch.commit();

  // Recurse on the next process tick, to avoid
  // exploding the stack.
  process.nextTick(() => {
    deleteQueryBatch(db, query, resolve);
  });
}

const firebaseConfig = {
  apiKey: "AIzaSyBlBJtz1oV7_pWAyjrlkxdJ7ZenisHP5sk",
  projectId: "boltconcierge-2f0f9",
  databaseURL: "https://boltconcierge-2f0f9.firebaseio.com",
  storageBucket: "boltconcierge-2f0f9.appspot.com",
};

class Firebase {
  static initialize() {
    firebase.initializeApp(firebaseConfig);
  }
  static storage() {
    return firebase.storage();
  }
  static getStorage() {
    return firebase.storage;
  }
  static firestore() {
    return firebase.firestore();
  }
  static getDB() {
    return firebase.database;
  }
  static getAuth = () => {
    return firebase.auth();
  };
  static isObjectTimestamp = (obj) => {
    return obj instanceof firebase.firestore.Timestamp;
  };
  static signUp(email, password, callback) {
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(function () {
        callback("success");
      })
      .catch(function (error) {
        callback(error.message);
      });
  }
  static signIn(email, password, callback) {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((res) => {
        callback("success");
      })
      .catch(function (error) {
        callback(error.message);
      });
  }
  static isEmailExisting(email_address) {
    let path = "agencies";
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(path)
        .on("value", (snapshot) => {
          snapshot.forEach((doc) => {
            const { email } = doc.val();
            if (email === email_address) resolve(true);
          });
          resolve(false);
        });
    });
  }
  static getPackageCount = (brand) => {
    let path = "brands/" + brand;
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(path)
        .on("value", (snapshot) => {
          let brand_data = snapshot.val();
          if (brand_data.packages) {
            let length = Object.values(brand_data.packages).length;
            resolve(length);
          } else resolve(0);
        });
    });
  };

  static async addPackage(packageData) {
    const { renter_owner, ...rest } = packageData;
    const path = "packages/";
    const order = await Firebase.getEcoPackagesLength();
    let newChild = firebase.database().ref(path).push();
    newChild.set({
      ...rest,
      active: true,
      for: renter_owner,
      order,
    });
  }
  static async addBrandPackage(packageData) {
    const { renter_owner, brand, ...rest } = packageData;
    const path = "brands/" + brand + "/packages/";
    const order = await Firebase.getPackageCount(brand);
    let newChild = firebase.database().ref(path).push();
    newChild.set({
      ...rest,
      active: true,
      for: renter_owner,
      order,
    });
  }

  static updateBrandPackageById(brand, packageId, data) {
    let path = "brands/" + brand + "/packages/" + packageId;
    return firebase.database().ref(path).update(data);
  }

  static deleteBrandPackageById(brand, id) {
    let path = "brands/" + brand + "/packages/" + id;
    return firebase.database().ref(path).remove();
  }

  static updateEcoPackageById(packageId, data) {
    let path = "packages/" + packageId;
    return firebase.database().ref(path).update(data);
  }
  static deleteEcoPackageById(id) {
    let path = "packages/" + id;
    return firebase.database().ref(path).remove();
  }

  static addAgency(email, password) {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then(function (data) {
          const { user } = data;
          resolve(user.uid);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  static addInvestor(email, password) {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then(function (data) {
          const { user } = data;
          resolve(user.uid);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  static addIntroducer(introducer_data) {
    return new Promise((resolve, reject) => {
      let path = "introducers";
      var newChild = firebase.database().ref(path).push();
      newChild
        .set(introducer_data)
        .then(() => {
          resolve(newChild.key);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  static updateIntroducer = (id, introducer_data) => {
    let path = "introducers/" + id;
    firebase.database().ref(path).update(introducer_data);
  };
  static inviteTasker(firstName, phoneNumber, skill, brand) {
    var newTasker = firebase.database().ref("taskers").push();
    return newTasker.set({ firstName, phoneNumber, skill, brand }).then(() => {
      return newTasker.key;
    });
  }

  static createRetailerAdmin(firstName, email, authId) {
    var newTasker = firebase.database().ref("retailer_admins").push();
    return newTasker.set({ firstName, email, authId, role: 5 }).then(() => {
      return newTasker.key;
    });
  }

  static updateRetailerAdmin(uid, retailerAdmin) {
    return firebase
      .database()
      .ref("retailer_admins/" + uid)
      .update(retailerAdmin);
  }

  static deleteRetailerAdmin(uid) {
    return firebase
      .database()
      .ref("retailer_admins/" + uid)
      .remove();
  }

  static getRetailerAdmin(id, callback) {
    let path = "retailer_admins/" + id;
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        var res = null;

        if (snapshot.val()) {
          res = snapshot.val();
        }
        callback(res);
      });
  }

  static getCurrentUser() {
    return firebase.auth().currentUser;
  }
  static getUserProfileById = (uid) => {
    return new Promise((resolve, reject) => {
      firebase
        .firestore()
        .collection("user")
        .doc(uid)
        .get()
        .then((res) => {
          resolve(res.data());
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
  static async getAllStoreIcons() {
    // let storageRef = this.storage().ref(`/services/store/`);
    const lettersRef = this.storage().ref(`/services/store/letters`);
    const standardRef = this.storage().ref(`/services/store/standard`);
    const { items: lettersItems } = await lettersRef.listAll();
    const { items: standardItems } = await standardRef.listAll();
    // const { items } = await storageRef.listAll();

    let promises1 = standardItems.map((imageRef) => {
      return this.displayImage(imageRef);
    });

    let promises2 = lettersItems.map((imageRef) => {
      return this.displayImage(imageRef);
    });
    // let promises3 = items.map((imageRef) => {
    //   return this.displayImage(imageRef);
    // });
    return await Promise.all([...promises1, ...promises2]);
  }

  static displayImage(imageRef) {
    return new Promise((resolve, reject) => {
      imageRef
        .getDownloadURL()
        .then((url) => {
          resolve(url);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  static writeAgencydata(agency_id, data) {
    let path = "agencies/" + agency_id;
    firebase
      .database()
      .ref(path)
      .set(data)
      .then(() => console.log(agency_id, "successfully created"))
      .catch((e) => console.log("write agency data error", e, data));
  }

  static writeInvestor(id, data) {
    let path = "investors/" + id;
    firebase.database().ref(path).set(data);
  }

  static getAgencyData(agency_id, callback) {
    let path = "agencies/" + agency_id;
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        var res = null;

        if (snapshot.val()) {
          res = snapshot.val();
        }
        callback(res);
      });
  }

  static addAdmin = async (data) => {
    try {
      await firebase.database().ref("agencies").push(data);
    } catch (e) {
      console.log("addAdmin error", e);
    }
  };

  static getAllAgencies(callback) {
    let path = "agencies";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        const users = [];
        snapshot.forEach((doc) => {
          users.push({
            id: doc.key,
            ...doc.val(),
          });
        });
        callback(users);
      });
  }

  static getAllIntroducers(callback) {
    let path = "introducers";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        const users = [];
        snapshot.forEach((doc) => {
          users.push({
            id: doc.key,
            ...doc.val(),
          });
        });
        callback(users);
      });
  }

  static getAllInvestor(callback) {
    let path = "investors";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        const users = [];
        snapshot.forEach((doc) => {
          users.push({
            id: doc.key,
            ...doc.val(),
          });
        });
        callback(users);
      });
  }

  static addAvatar(uid, content) {
    return new Promise((resolve, reject) => {
      let storageRef = this.storage().ref(`/avatars/${uid}.png`);
      storageRef
        .putString(content, "base64")
        .then(function (snap) {
          storageRef
            .getDownloadURL()
            .then(function (url) {
              resolve(url);
            })
            .catch((error) => {
              reject(error);
              console.log(error.message);
            });
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  static addIFrameIcon(file_name, content) {
    return new Promise((resolve, reject) => {
      let storageRef = this.storage().ref(`/iframe/${file_name}.png`);
      storageRef
        .putString(content, "base64")
        .then(function (snap) {
          storageRef
            .getDownloadURL()
            .then(function (url) {
              resolve(url);
            })
            .catch((error) => {
              reject(error);
              console.log(error.message);
            });
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  static updateAgencyData(agency_id, data) {
    let path = "agencies/" + agency_id;
    return firebase.database().ref(path).update(data);
  }

  static updateInvestorData(id, data) {
    let path = "investors/" + id;
    firebase.database().ref(path).update(data);
  }

  static getAgencyByBrandID(brand, callback) {
    let brand_str = "" + brand;
    let path = "agencies";
    firebase
      .database()
      .ref(path)
      .orderByChild("role")
      .equalTo(2)
      .on("value", (snapshot) => {
        let res = [];
        let result = [];
        if (snapshot.val()) res = Object.values(snapshot.val());
        res.forEach((item) => {
          let item_brand = "" + item.brand;
          if (item_brand === brand_str) result.push(item);
        });
        callback(result);
      });
  }

  static getAgencyByEmail = async (email) => {
    try {
      const querySnapshot = await firebase
        .database()
        .ref("agencies")
        .orderByChild("email")
        .equalTo(email)
        .once("value");

      if (!querySnapshot.exists()) return null;

      return querySnapshot.val();
    } catch (e) {
      console.log("getAgencyByEmail() error", e);
    }
  };

  static getDevelopersByBrandID(brand, callback) {
    let brand_str = "" + brand;
    let path = "agencies";
    firebase
      .database()
      .ref(path)
      .orderByChild("role")
      .equalTo(20)
      .on("value", (snapshot) => {
        let res = [];
        let result = [];
        if (snapshot.val()) res = Object.values(snapshot.val());
        res.forEach((item) => {
          let item_brand = "" + item.brand;
          if (item_brand === brand_str) result.push(item);
        });
        callback(result);
      });
  }

  static getTaskersByBrandID(brand, callback) {
    let path = "taskers";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        let result = [];
        const snapshotValues = snapshot.val();
        if (!snapshotValues) {
          callback(result);
          return;
        }

        const ids = _.keys(snapshotValues);
        ids.forEach((id) => {
          if (snapshotValues[id].brand === brand)
            result.push({
              ...snapshotValues[id],
              id,
            });
        });
        callback(result);
      });
  }

  static removeTasker(uid) {
    const path = `taskers/${uid}`;
    firebase.database().ref(path).remove();
  }

  static removeAgency(uid) {
    const path = `agencies/${uid}`;
    firebase.database().ref(path).remove();
  }

  static removeInvestor(uid) {
    const path = `investors/${uid}`;
    firebase.database().ref(path).remove();
  }

  static removeDeveloper(uid) {
    const path = `developers/${uid}`;
    firebase.database().ref(path).remove();
  }

  static approveAgency(uid) {
    let path = "agencies/" + uid;
    firebase.database().ref(path).update({ approved: true });
  }
  static getServicesRouting = (brand_name) => {
    let path = "brands";
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(path)
        .orderByChild("name")
        .equalTo(brand_name)
        .on("value", (snapshot) => {
          let result = [];
          result = snapshot.val();
          let res = Object.values(result)[0];
          resolve(res.services_routing);
        });
    });
  };
  static getGlobalServicesRouting = () => {
    let path = "chatbot/service_routing";
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(path)
        .on("value", (snapshot) => {
          let result = [];
          result = snapshot.val();
          //let res = Object.values(result)[0];
          resolve(result);
        });
    });
  };
  static getEcoPackages = (callback) => {
    let path = "packages/";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        let result = [];
        result = snapshot.val();
        //let res = Object.values(result)[0];
        callback(result);
      });
  };
  static getEcoPackagesLength = (callback) => {
    let path = "packages/";
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(path)
        .on("value", (snapshot) => {
          let result = [];
          result = snapshot.val();
          //let res = Object.values(result)[0];
          let length = Object.values(result).length;
          resolve(length);
        });
    });
  };
  static updateGlobalService = (service_routing) => {
    let path = "chatbot/";
    firebase.database().ref(path).update({ service_routing: service_routing });
  };
  static updateGlobalPackage = (id, data) => {
    let path = "packages/" + id;
    firebase.database().ref(path).update(data);
  };
  static updateBrandPackage = (brand, id, data) => {
    let path = "brands/" + brand + "/packages/" + id;
    firebase.database().ref(path).update(data);
  };
  static getTier1byID = (tier1_id) => {
    let path = "tier1/" + tier1_id;
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(path)
        .once("value", (snapshot) => {
          let result = snapshot.val();
          resolve(result);
        });
    });
  };
  static getCategorybyID = (category_id) => {
    let path = "categories/" + category_id;
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(path)
        .once("value", (snapshot) => {
          let result = snapshot.val();
          resolve(result);
        });
    });
  };
  static addTier1(url, title) {
    return new Promise((resolve, reject) => {
      let path = "tier1";
      var newChild = firebase.database().ref(path).push();
      newChild
        .set({ src: url, title: title })
        .then(() => {
          resolve(newChild.key);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  static async addNewCategory(url, title, site_url) {
    return new Promise((resolve, reject) => {
      let path = "categories/";
      var newChild = firebase.database().ref(path).push();
      newChild
        .set({
          image: url,
          topic: title,
          manual_chatbot: 0,
          packageA: "N/A",
          packageB: "N/A",
          packageC: "N/A",
          site_url: site_url ? site_url : null,
        })
        .then(() => {
          resolve(newChild.key);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  static getTier1Count = () => {
    return new Promise((resolve, reject) => {
      let path = "tier1";
      firebase
        .database()
        .ref(path)
        .on("value", (snapshot) => {
          let result = snapshot.val();
          resolve(result.length);
        });
    });
  };
  static getTier2Count = () => {
    return new Promise((resolve, reject) => {
      let path = "categories";
      firebase
        .database()
        .ref(path)
        .on("value", (snapshot) => {
          let result = snapshot.val();
          resolve(result.length);
        });
    });
  };
  static getTop10Perks = (callback) => {
    let path = "offers/top_10perks";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        let result = [];
        result = snapshot.val();
        if (result) {
          let res = Object.values(result);
          callback(res);
        } else {
          callback([]);
        }
      });
  };
  static getAllOffers = (callback) => {
    let path = "offers/redeem_offers";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        let result = [];
        result = snapshot.val();
        let res = Object.values(result);
        callback(res);
      });
  };
  static addSuperOffer = (id, offer) => {
    let path = "offers/redeem_offers/" + id;
    firebase.database().ref(path).set(offer);
  };

  static updateSuperOffer = (id, offer) => {
    let path = "offers/redeem_offers/" + id;
    firebase.database().ref(path).update(offer);
  };

  static getAllDeactiveOffers = (callback) => {
    let path = "offers/deactive_offers";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        let result = [];
        if (snapshot.val()) result = snapshot.val();
        callback(result);
      });
  };
  static updateRetailerToken = (threshold, redemption, index) => {
    let path = "retailers/tokens/" + index;
    firebase.database().ref(path).update({ threshold, redemption });
  };

  static deleteRetailerToken = (id) => {
    const path = `retailers/all/${id}`;
    firebase.database().ref(path).remove();
  };

  static createRetailer = (retailer) => {
    let path = "retailers/all";
    const ref = firebase.database().ref(path).push();

    ref.set(retailer).then((res) => console.log(res));
  };

  static createNCRetailer = (retailer) => {
    let path = "nc_retailers/all";
    const ref = firebase.database().ref(path).push();

    ref.set(retailer).then((res) => console.log(res));
  };

  static getAllNCRetailers(callback) {
    let path = "nc_retailers/all";
    firebase
      .database()
      .ref(path)
      .once("value", (snapshot) => {
        callback(snapshot.val());
      });
  }

  static updateNCRetailer = (retailer, id) => {
    const path = `nc_retailers/all/${id}`;
    firebase.database().ref(path).update(retailer);
  };

  static updateRetailer = (retailer, id) => {
    const path = `retailers/all/${id}`;
    firebase.database().ref(path).update(retailer);
  };

  static updateDeactiveOffers = (array) => {
    let path = "offers/";
    firebase.database().ref(path).update({ deactive_offers: array });
  };

  static getAllRetailers(callback) {
    let path = "retailers/all";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        callback(snapshot.val());
      });
  }

  static getRetailerById(retailerId, callback) {
    let path = `retailers/all/${retailerId}`;
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        callback(snapshot.val());
      });
  }

  static getAllEcoEarnRetailers(callback) {
    let path = "eco_earn/all";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        callback(snapshot.val());
      });
  }

  static updateEcoEarnRetailer = (retailer, id) => {
    const path = `eco_earn/all/${id}`;
    firebase.database().ref(path).update(retailer);
  };

  static getAllDeactiveEcoEarnRetailers = (callback) => {
    let path = "eco_earn/deactive";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        let result = [];
        if (snapshot.val()) result = snapshot.val();
        callback(result);
      });
  };

  static updateDeactiveEcoEarnRetailers = (array) => {
    let path = "eco_earn/";
    firebase.database().ref(path).update({ deactive: array });
  };

  static getAllTokens(callback) {
    let path = "retailers/tokens";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        callback(snapshot.val());
      });
  }
  static getAllDeactiveNCRetailers = (callback) => {
    let path = "nc_retailers/deactive";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        let result = [];
        if (snapshot.val()) result = snapshot.val();
        callback(result);
      });
  };
  static getAllDeactiveRetailers = (callback) => {
    let path = "retailers/deactive";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        let result = [];
        if (snapshot.val()) result = snapshot.val();
        callback(result);
      });
  };
  static getAllTokenWallets(callback) {
    let path = "tokenWallets";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        callback(snapshot.val());
      });
  }

  static createTokenWallet = (tokenWallet) => {
    let path = "tokenWallets";
    const ref = firebase.database().ref(path).push();

    ref.set(tokenWallet);
  };

  static updateTokenWallet = (id, tokenWallet) => {
    let path = `tokenWallets/${id}`;
    firebase.database().ref(path).update(tokenWallet);
  };

  static updateDeactiveRetailers = (array) => {
    let path = "retailers/";
    firebase.database().ref(path).update({ deactive: array });
  };
  static getAllBrands(callback) {
    let path = "brands";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        callback(snapshot.val());
      });
  }

  static getAllBrandsOnce(callback) {
    let path = "brands";
    firebase
      .database()
      .ref(path)
      .once("value", (snapshot) => {
        callback(snapshot.val());
      });
  }

  static getBrandDataByID(brand, callback) {
    let path = "brands/" + brand;
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        callback(snapshot.val());
      });
  }

  static getBrandIconByID = async (brandId) => {
    let path = "brands/" + brandId;
    try {
      const res = await firebase.database().ref(path).get();
      const iconUrl = res.val().icon;
      return iconUrl;
    } catch (err) {
      console.log("getBrandIconByID() error", err);
      return null;
    }
  };
  static getDashboardData(brandName, callback) {
    const dashboardDocRef = firebase
      .firestore()
      .collection("analytics")
      .doc(brandName)
      .collection("data")
      .doc("dashboard");

    dashboardDocRef.get().then((documentSnapshot) => {
      if (documentSnapshot.exists) {
        callback(documentSnapshot.data());
      } else {
        callback({});
      }
    });
  }

  static async addUnreadMessage(brand_name, uid, sender_id, data) {
    let unreadCollection = firebase
      .firestore()
      .collection(brand_name)
      .doc("data")
      .collection("user")
      .doc(uid)
      .collection("unreads");

    let unreadCollectionExists = await unreadCollection
      .get()
      .then((snapshot) => {
        return !snapshot.empty;
      });

    console.log("#####close:", unreadCollectionExists);

    // If collection does not exist, create collection
    // if (!unreadCollectionExists) {
    //   await unreadCollection.;
    // }

    // Update document (sender_id) with data by merging
    let fbInstance = firebase
      .firestore()
      .collection(brand_name)
      .doc("data")
      .collection("user")
      .doc(uid)
      .collection("unreads")
      .add({ sender_id, ...data });
    // const snapshot = await fbInstance.get();
    // let original_data = {};
    // if (snapshot.data()) original_data = snapshot.data();
    // const currentCount = Object.keys(original_data).length;
    //const res = await fbInstance.set({ [currentCount]: data }, { merge: true });
    // const res = await fbInstance.set(data, { merge: true });
    // return res;
  }
  static getAllUsersInBrand(brand) {
    if (brand === "EcosystemDemo") {
      return Firebase.firestore()
        .collection("user")
        .get()
        .then((snapshot) => {
          return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        });
    } else {
      return Firebase.firestore()
        .collection(brand)
        .doc("data")
        .collection("user")
        .limit(50)
        .get()
        .then((snapshot) => {
          return snapshot.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          });
        });
    }
  }
  static getPaginatedFullUsers(brand, lastsnapshot) {
    if (lastsnapshot) {
      const lastVisible = lastsnapshot.docs[lastsnapshot.docs.length - 1];
      return Firebase.firestore()
        .collection(brand)
        .doc("data")
        .collection("user")
        .orderBy("eco_id")
        .startAfter(lastVisible)
        .limit(25)
        .get()
        .then((snapshot) => {
          return snapshot;
        });
    } else {
      return Firebase.firestore()
        .collection(brand)
        .doc("data")
        .collection("user")
        .orderBy("eco_id")
        .limit(25)
        .get()
        .then((snapshot) => {
          return snapshot;
        });
    }
  }
  static getPaginatedUsers(brand, lastsnapshot, filters = {}) {
    let userRef = Firebase.firestore()
      .collection(brand)
      .doc("data")
      .collection("user");

    // filter documents to return
    if (Object.keys(filters).length) {
      Object.keys(filters).forEach((filter) => {
        userRef = userRef.where(filter, "==", filters[filter]);
      });
    }

    if (lastsnapshot) {
      const lastVisible = lastsnapshot.docs[lastsnapshot.docs.length - 1];
      return userRef
        .orderBy("firstname")
        .startAfter(lastVisible)
        .limit(50)
        .get()
        .then((snapshot) => {
          return {
            users: snapshot.docs.map((doc) => {
              return {
                id: doc.id,
                ...doc.data(),
              };
            }),
            snapshot: snapshot,
          };
        });
    } else {
      return userRef
        .orderBy("firstname")
        .limit(50)
        .get()
        .then((snapshot) => {
          return {
            users: snapshot.docs.map((doc) => {
              return {
                id: doc.id,
                ...doc.data(),
              };
            }),
            snapshot: snapshot,
          };
        })
        .catch((err) => console.log("getPaginatedUsers error", err));
    }
  }
  static getAllPosts(brand, callback) {
    if (brand === "EcosystemDemo") {
      Firebase.firestore()
        .collection("post")
        .onSnapshot((docSnapshot) => {
          const posts = [];
          docSnapshot.forEach((doc) => {
            posts.push({
              id: doc.id,
              ...doc.data(),
            });
          });
          callback(posts);
        });
    } else {
      Firebase.firestore()
        .collection(brand)
        .doc("data")
        .collection("post")
        .onSnapshot((docSnapshot) => {
          const posts = [];
          docSnapshot.forEach((doc) => {
            posts.push({
              id: doc.id,
              ...doc.data(),
            });
          });
          callback(posts);
        });
    }
  }
  static getAllPostsPromise(brandName) {
    return new Promise((resolve, reject) => {
      if (brandName === "EcosystemDemo") {
        Firebase.firestore()
          .collection("post")
          .onSnapshot((docSnapshot) => {
            const posts = [];
            docSnapshot.forEach((doc) => {
              posts.push({
                id: doc.id,
                ...doc.data(),
              });
            });
            resolve(posts);
          });
      } else {
        Firebase.firestore()
          .collection(brandName)
          .doc("data")
          .collection("post")
          .onSnapshot((docSnapshot) => {
            const posts = [];
            docSnapshot.forEach((doc) => {
              posts.push({
                id: doc.id,
                ...doc.data(),
              });
            });
            resolve(posts);
          });
      }
    });
  }
  static getAllCauses(brand, callback) {
    Firebase.firestore()
      .collection(brand)
      .doc("data")
      .collection("cause")
      .onSnapshot((docSnapshot) => {
        const causes = [];
        docSnapshot.forEach((doc) => {
          causes.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        callback(causes);
      });
  }
  static getAllEvents(brand, callback) {
    Firebase.firestore()
      .collection(brand)
      .doc("data")
      .collection("event")
      .onSnapshot((docSnapshot) => {
        const events = [];
        docSnapshot.forEach((doc) => {
          events.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        callback(events);
      });
  }
  static getRegistrationsByBrand(brandName, callback) {
    Firebase.firestore()
      .collection(brandName)
      .doc("data")
      .collection("user")
      .where("register_date", "!=", null)
      .orderBy("register_date")
      .onSnapshot((docSnapshot) => {
        console.log("snapshot:", docSnapshot);
        callback(
          docSnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
        );
      });
  }

  static getAllNotifications = (brand_name, callback) => {
    let fbInstance;
    if (brand_name === "Ecosystem") {
      fbInstance = firebase.firestore().collection("notifications");
    } else {
      fbInstance = firebase
        .firestore()
        .collection(brand_name)
        .doc("data")
        .collection("notifications");
    }
    fbInstance.onSnapshot((docSnapshot) => {
      const notifications = [];
      docSnapshot.forEach((doc) => {
        notifications.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      callback(notifications);
    });
  };

  static getReferralsByBrand(brandName, callback) {
    Firebase.firestore()
      .collection(brandName)
      .doc("data")
      .collection("referrals")
      .orderBy("time")
      .onSnapshot((docSnapshot) => {
        const referrals = [];
        docSnapshot.forEach((doc) => {
          referrals.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        callback(referrals);
      });
  }
  static deleteReferral(brand_name, id) {
    if (brand_name === "EcosystemDemo") {
      Firebase.firestore().collection("referrals").doc(id).delete();
    } else {
      Firebase.firestore()
        .collection(brand_name)
        .doc("data")
        .collection("referrals")
        .doc(id)
        .delete();
    }
  }
  static getAllPerks(brand, callback) {
    Firebase.firestore()
      .collection(brand)
      .doc("data")
      .collection("perks")
      .onSnapshot((docSnapshot) => {
        const perks = [];
        docSnapshot.forEach((doc) => {
          perks.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        callback(perks);
      });
  }
  static getAllHotTopics(brand, callback) {
    Firebase.firestore()
      .collection(brand)
      .doc("data")
      .collection("hotTopic")
      .onSnapshot((docSnapshot) => {
        const hotTopics = [];
        docSnapshot.forEach((doc) => {
          hotTopics.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        callback(hotTopics);
      });
  }
  static getAllFeaturedContent(brand, callback) {
    Firebase.firestore()
      .collection(brand)
      .doc("data")
      .collection("featuredContent")
      .onSnapshot((docSnapshot) => {
        const featuredContent = [];
        docSnapshot.forEach((doc) => {
          featuredContent.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        callback(featuredContent);
      });
  }
  static getHotTopic(brand, id) {
    return new Promise((resolve, reject) => {
      Firebase.firestore()
        .collection(brand)
        .doc("data")
        .collection("hotTopic")
        .doc(id)
        .get()
        .then((res) => {
          resolve(res.data());
        });
    });
  }
  static updateHotTopic(brand, id, payload) {
    return new Promise((resolve, reject) => {
      Firebase.firestore()
        .collection(brand)
        .doc("data")
        .collection("hotTopic")
        .doc(id)
        .update(payload)
        .then((res) => {
          resolve(res);
        });
    });
  }
  static getAllBrandOffers(brand, callback) {
    if (brand === "EcosystemDemo") {
      Firebase.firestore()
        .collection("offer")
        .onSnapshot((docSnapshot) => {
          const offers = [];
          docSnapshot.forEach((doc) => {
            offers.push({
              id: doc.id,
              ...doc.data(),
            });
          });
          callback(offers);
        });
    } else {
      Firebase.firestore()
        .collection(brand)
        .doc("data")
        .collection("perks")
        .onSnapshot((docSnapshot) => {
          const offers = [];
          docSnapshot.forEach((doc) => {
            offers.push({
              id: doc.id,
              ...doc.data(),
            });
          });
          callback(offers.filter((o) => o.type === "perk"));
        });
    }
  }

  static getAllCompetitions(brand, callback) {
    if (brand === "EcosystemDemo") {
      Firebase.firestore()
        .collection("competitions")
        .onSnapshot((docSnapshot) => {
          const posts = [];
          docSnapshot.forEach((doc) => {
            posts.push({
              id: doc.id,
              ...doc.data(),
            });
          });
          callback(posts);
        });
    } else {
      Firebase.firestore()
        .collection(brand)
        .doc("data")
        .collection("competitions")
        .onSnapshot((docSnapshot) => {
          const posts = [];
          docSnapshot.forEach((doc) => {
            posts.push({
              id: doc.id,
              ...doc.data(),
            });
          });
          callback(posts);
        });
    }
  }

  static getAllPostOnce(brand, callback) {
    if (brand === "EcosystemDemo") {
      Firebase.firestore()
        .collection("post")
        .get()
        .then((docSnapshot) => {
          const posts = [];
          docSnapshot.forEach((doc) => {
            posts.push({
              id: doc.id,
              ...doc.data(),
            });
          });
          callback(posts);
        });
    } else {
      Firebase.firestore()
        .collection(brand)
        .doc("data")
        .collection("post")
        .get()
        .then((docSnapshot) => {
          const posts = [];
          docSnapshot.forEach((doc) => {
            posts.push({
              id: doc.id,
              ...doc.data(),
            });
          });
          callback(posts);
        });
    }
  }

  static getAllUsers(brand, callback) {
    if (brand === "EcosystemDemo") {
      Firebase.firestore()
        .collection("user")
        .onSnapshot((docSnapshot) => {
          const users = [];
          docSnapshot.forEach((doc) => {
            users.push({
              id: doc.id,
              ...doc.data(),
            });
          });
          callback(users);
        });
    } else {
      Firebase.firestore()
        .collection(brand)
        .doc("data")
        .collection("user")
        .onSnapshot((docSnapshot) => {
          const users = [];
          docSnapshot.forEach((doc) => {
            users.push({
              id: doc.id,
              ...doc.data(),
            });
          });
          callback(users);
        });
    }
  }

  static updatePost(brand, id, post) {
    if (brand === "EcosystemDemo") {
      return Firebase.firestore().collection("post").doc(id).update(post);
    } else {
      return Firebase.firestore()
        .collection(brand)
        .doc("data")
        .collection("post")
        .doc(id)
        .update(post);
    }
  }

  static deletePost(brand, id) {
    if (brand === "EcosystemDemo") {
      Firebase.firestore().collection("post").doc(id).delete();
    } else {
      Firebase.firestore()
        .collection(brand)
        .doc("data")
        .collection("post")
        .doc(id)
        .delete();
    }
  }

  static async addPost(post, brand_name) {
    const timestamp = await firebase.firestore.Timestamp.fromDate(new Date());
    post.accepted = "true";
    post.from_admin = true;
    post.timestamp = timestamp;
    return firebase
      .firestore()
      .collection(brand_name)
      .doc("data")
      .collection("post")
      .add(post);
  }
  static async addGoal(goal, brand_name) {
    const timestamp = await firebase.firestore.Timestamp.fromDate(new Date());
    goal.from_admin = true;
    goal.timestamp = timestamp;
    return firebase
      .firestore()
      .collection(brand_name)
      .doc("data")
      .collection("goal")
      .add(goal);
  }
  static addConciergeBot(concierge_bot, brand_name) {
    return firebase
      .firestore()
      .collection(brand_name)
      .doc("data")
      .collection("concierge_bot")
      .add(concierge_bot);
  }
  static addArticle(article, brand_name) {
    return firebase
      .firestore()
      .collection(brand_name)
      .doc("data")
      .collection("articles")
      .add(article);
  }
  static removeArticle(articleId, brand_name) {
    return firebase
      .firestore()
      .collection(brand_name)
      .doc("data")
      .collection("articles")
      .doc(articleId)
      .delete();
  }
  static addToChecklist(checklist, brand_name, category) {
    return firebase
      .firestore()
      .collection(brand_name)
      .doc("data")
      .collection("checklist")
      .doc("data")
      .collection(category)
      .add(checklist);
  }
  static updateArticle(brand, id, article) {
    return Firebase.firestore()
      .collection(brand)
      .doc("data")
      .collection("articles")
      .doc(id)
      .update(article);
  }
  static addBespokeArticle(article, brand_name) {
    return new Promise((resolve, reject) => {
      firebase
        .firestore()
        .collection(brand_name)
        .doc("data")
        .collection("bespoke_articles")
        .add(article)
        .then((res) => resolve(res.id))
        .catch((e) => reject(e));
    });
  }
  static updateBespokeArticle(brand_name, id, article) {
    return Firebase.firestore()
      .collection(brand_name)
      .doc("data")
      .collection("bespoke_articles")
      .doc(id)
      .update(article);
  }
  static getBespokeArticleById(brandName, id) {
    return new Promise((resolve, reject) => {
      Firebase.firestore()
        .collection(brandName)
        .doc("data")
        .collection("bespoke_articles")
        .doc(id)
        .get()
        .then((res) => {
          resolve({ ...res.data(), id });
        });
    });
  }
  static addCause(cause, brand_name) {
    return firebase
      .firestore()
      .collection(brand_name)
      .doc("data")
      .collection("cause")
      .add(cause);
  }
  static addEvent(event, brand_name) {
    return firebase
      .firestore()
      .collection(brand_name)
      .doc("data")
      .collection("event")
      .add(event);
  }
  static addPerk(perk, brand_name) {
    return firebase
      .firestore()
      .collection(brand_name)
      .doc("data")
      .collection("perks")
      .add(perk);
  }
  static addHotTopic(hotTopic, brand_name) {
    return firebase
      .firestore()
      .collection(brand_name)
      .doc("data")
      .collection("hotTopic")
      .add(hotTopic);
  }
  static addFeaturedContent(featuredContent, brand_name) {
    return firebase
      .firestore()
      .collection(brand_name)
      .doc("data")
      .collection("featuredContent")
      .add(featuredContent);
  }
  static async deleteFeaturedContent(brandName, id, url, mediaType) {
    try {
      if (mediaType !== YOUTUBE_URL) {
        // 1. delete file from Google Cloud Storage
        const path = getFilePath("hotVideos", url, mediaType);
        const assetRef = firebase.storage().ref(path);
        path && (await assetRef.delete());
      }

      // 2. delete file URL from featuredContent collection
      await firebase
        .firestore()
        .collection(brandName)
        .doc("data")
        .collection("featuredContent")
        .doc(id)
        .delete();
    } catch (err) {
      console.log("DeleteFeaturedContent() error", err);
    }
  }
  static addBrandOffer(brand_name, offer) {
    if (brand_name === "EcosystemDemo") {
      return firebase.firestore().collection("offer").add(offer);
    } else {
      return firebase
        .firestore()
        .collection(brand_name)
        .doc("data")
        .collection("offer")
        .add(offer);
    }
  }

  static async addCompetition(competitions, brand_name) {
    const timestamp = await firebase.firestore.Timestamp.fromDate(new Date());
    if (brand_name === "EcosystemDemo") {
      return firebase.firestore().collection("competitions").add({
        title: competitions.title,
        content: competitions.content,
        uid: competitions.uid,
        timestamp: timestamp,
        img_url: competitions.image_url,
        task: competitions.task,
        accepted: true,
        from_admin: true,
        scheduledDate: competitions.scheduledDate,
        postNow: competitions.postNow,
        runUntil: competitions.runUntil,
      });
    } else {
      return firebase
        .firestore()
        .collection(brand_name)
        .doc("data")
        .collection("competitions")
        .add({
          title: competitions.title,
          content: competitions.content,
          uid: competitions.uid,
          timestamp: timestamp,
          img_url: competitions.image_url,
          task: competitions.task,
          accepted: true,
          from_admin: true,
          scheduledDate: competitions.scheduledDate,
          postNow: competitions.postNow,
          runUntil: competitions.runUntil,
          hot_topic: competitions.hot_topic,
        });
    }
  }

  static deleteCompetition(brand, id) {
    if (brand === "EcosystemDemo") {
      Firebase.firestore().collection("competitions").doc(id).delete();
    } else {
      Firebase.firestore()
        .collection(brand)
        .doc("data")
        .collection("competitions")
        .doc(id)
        .delete();
    }
  }

  static async addPurePost(post, brand_name) {
    const timestamp = await firebase.firestore.Timestamp.fromDate(new Date());
    if (brand_name === "EcosystemDemo") {
      return firebase.firestore().collection("post").add({
        title: post.title,
        content: post.content,
        uid: post.uid,
        timestamp: timestamp,
        img_url: post.image_url,
        type: post.type,
        topic: post.topic,
        accepted: post.accepted,
        from_admin: post.from_admin,
        postNow: post.postNow,
      });
    } else {
      return firebase
        .firestore()
        .collection(brand_name)
        .doc("data")
        .collection("post")
        .add({
          title: post.title,
          content: post.content,
          uid: post.uid,
          timestamp: timestamp,
          img_url: post.image_url,
          type: post.type,
          topic: post.topic,
          accepted: post.accepted,
          from_admin: post.from_admin,
          postNow: post.postNow,
        })
        .then((e) => console.log(e))
        .catch((e) => console.log("error", e));
    }
  }

  static async removePost(postId, brand_name) {
    if (brand_name === "EcosystemDemo") {
      return firebase.firestore().collection("post").doc(postId).delete();
    } else {
      return firebase
        .firestore()
        .collection(brand_name)
        .doc("data")
        .collection("post")
        .doc(postId)
        .delete();
    }
  }

  static removeFromChecklist = (brand_name, category, order) => {
    return new Promise((resolve, reject) => {
      let fbInstance;
      if (brand_name === "Ecosystem") {
        fbInstance = firebase
          .firestore()
          .collection("checklist")
          .doc("data")
          .collection(category);
      } else {
        fbInstance = firebase
          .firestore()
          .collection(brand_name)
          .doc("data")
          .collection("checklist")
          .doc("data")
          .collection(category);
      }
      fbInstance
        .where("order", "==", order)
        .get()
        .then((res) => {
          if (!res.docs.length) reject("Error");
          const id = res.docs[0].id;
          fbInstance.doc(id).delete();
          resolve("success");
        })
        .catch((e) => reject(e));
    });
  };

  static getAllTokenEarnings(callback) {
    return Firebase.firestore()
      .collection("token_earning")
      .onSnapshot((docSnapshot) => {
        const tokenEarnings = [];
        docSnapshot.forEach((doc) => {
          tokenEarnings.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        callback(tokenEarnings.sort((a, b) => a.title.localeCompare(b.title)));
      });
  }

  static updateUserData = (brand_name, uid, data) => {
    return new Promise((resolve, reject) => {
      let fbInstance;
      if (brand_name === "Ecosystem") {
        fbInstance = firebase.firestore().collection("user");
      } else {
        fbInstance = firebase
          .firestore()
          .collection(brand_name)
          .doc("data")
          .collection("user");
      }

      fbInstance
        .doc(`${uid}`)
        .set(data, { merge: true })
        .then((res) => {
          fbInstance
            .doc(`${uid}`)
            .get()
            .then((res) => {
              resolve(res.data());
            })
            .catch((err) => {
              reject(err);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  static updateEcoUser(eco_id, data) {
    return firebase
      .firestore()
      .collection("ecosystem_user")
      .doc(eco_id)
      .set(data, { merge: true });
  }
  static saveTokenSpentHistory = (brand_name, uid, data) => {
    return new Promise((resolve, reject) => {
      let fbInstance;
      if (brand_name === "Ecosystem") {
        fbInstance = firebase.firestore().collection("user");
      } else {
        fbInstance = firebase
          .firestore()
          .collection(brand_name)
          .doc("data")
          .collection("user");
      }

      fbInstance
        .doc(`${uid}`)
        .collection("token_history")
        .add(data)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static async addTokenEarning(tokenEarning) {
    return Firebase.firestore().collection("token_earning").add(tokenEarning);
  }

  static editTokenEarning(id, tokenEarning) {
    Firebase.firestore()
      .collection("token_earning")
      .doc(id)
      .update(tokenEarning);
  }

  static updateBrandDataById(brand, data) {
    let path = "brands/" + brand;
    return firebase.database().ref(path).update(data);
  }

  static updateBrandIframesById(brand, iframeIndex, data) {
    let path = "brands/" + brand + "/iframes/" + iframeIndex;
    return firebase.database().ref(path).update(data);
  }

  static addBrandSurvey(brand, survey) {
    let path = `brands/${brand}/surveys`;
    return firebase.database().ref(path).push(survey);
  }

  static updateSurveyById(brand, id, survey) {
    let path = `brands/${brand}/surveys/${id}`;
    return firebase.database().ref(path).update(survey);
  }

  static deleteSurveyById(brand, id) {
    let path = `brands/${brand}/surveys/${id}`;
    return firebase.database().ref(path).remove();
  }

  static addBrandChatbot(brand, chatbot) {
    let path = `brands/${brand}/chatbots`;
    return firebase.database().ref(path).push(chatbot);
  }

  static updateChatbotById(brand, id, chatbot) {
    let path = `brands/${brand}/chatbots/${id}`;
    return firebase.database().ref(path).update(chatbot);
  }

  static deleteChatbotById(brand, id) {
    let path = `brands/${brand}/chatbots/${id}`;
    return firebase.database().ref(path).remove();
  }

  static getAllChatRequest(callback) {
    let path = "livechat";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        var res = [];

        if (snapshot.val()) {
          res = snapshot.val();
        }
        callback(res);
      });
  }

  static getChats(room_id, ticket_id, callback) {
    let ticket = "" + ticket_id;
    let child_id = ticket.split(".").join("");
    let path = "livechat/" + room_id + "/tickets/" + child_id + "/content";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        var res = [];

        if (snapshot.val()) {
          res = snapshot.val();
        }

        callback(res);
      });
  }
  static getSupportChat(brand_id, ticket_id, callback) {
    let path = "admin_support/" + brand_id + "/" + ticket_id + "/content";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        var res = [];

        if (snapshot.val()) {
          res = snapshot.val();
        }

        callback(res);
      });
  }
  static addSupportMessage(brand_id, ticket_id, message, callback) {
    let path = "admin_support/" + brand_id + "/" + ticket_id + "/content";
    var newChild = firebase.database().ref(path).push();
    newChild.set(message, callback);
    let time = new Date().getTime().toString();
    path = "admin_support/" + brand_id + "/" + ticket_id;
    firebase.database().ref(path).update({ time });
  }
  static addSupportMessages(brand_id, ticket_id, messages) {
    let path = "admin_support/" + brand_id + "/" + ticket_id + "/content";
    messages.forEach((message) => {
      var newChild = firebase.database().ref(path).push();
      newChild.set(message);
      let time = new Date().getTime().toString();
      const outpath = "admin_support/" + brand_id + "/" + ticket_id;
      firebase.database().ref(outpath).update({ time });
    });
  }
  static setAdminTypeValue(brand_id, ticket_id, value) {
    let path = "admin_support/" + brand_id + "/" + ticket_id;
    firebase.database().ref(path).update({ admin_typing: value });
  }
  static setBrandTypeValue(brand_id, ticket_id, value) {
    let path = "admin_support/" + brand_id + "/" + ticket_id;
    firebase.database().ref(path).update({ brand_typing: value });
  }
  static getAdminTyping(brand_id, ticket_id, callback) {
    let path = "admin_support/" + brand_id + "/" + ticket_id + "/admin_typing";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        if (snapshot.val()) callback(snapshot.val());
        else callback(false);
      });
  }
  static getBrandTyping(brand_id, ticket_id, callback) {
    let path = "admin_support/" + brand_id + "/" + ticket_id + "/brand_typing";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        if (snapshot.val()) callback(snapshot.val());
        else callback(false);
      });
  }
  static createTicket = (uid, firstname, brand, ticket) => {
    let data = {
      uid: uid,
      username: firstname,
    };
    data.brand = brand;
    let path = "livechat/" + uid;
    firebase.database().ref(path).update(data);
    let ticket_id = "" + ticket.id;
    let child_id = ticket_id.split(".").join("");
    let ticket_path = "livechat/" + uid + "/tickets/" + child_id;
    return firebase.database().ref(ticket_path).set(ticket);
  };
  static addHistory = (brand_name, uid, history) => {
    return new Promise((resolve, reject) => {
      let fbInstance;

      fbInstance = firebase
        .firestore()
        .collection(brand_name)
        .doc("data")
        .collection("user");

      fbInstance
        .doc(`${uid}`)
        .collection("histories")
        .add(history)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  static getLatestChatTimebyID(room_id, ticket_id) {
    let ticket = "" + ticket_id;
    let child_id = ticket.split(".").join("");
    let path = "livechat/" + room_id + "/tickets/" + child_id + "/content";
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(path)
        .once("value", (snapshot) => {
          var res = [];
          if (snapshot.val()) {
            res = snapshot.val();
            const messages_array = Object.values(res);
            let max = 0;
            for (let i = 0; i < messages_array.length; i++) {
              if (parseInt(messages_array[i].time) > max)
                max = messages_array[i].time;
            }
            resolve(max);
          }
          resolve(0);
        });
    });
  }
  static getStatus(room_id, ticket_id, callback) {
    let ticket = "" + ticket_id;
    let child_id = ticket.split(".").join("");
    let path = "livechat/" + room_id + "/tickets/" + child_id + "/status";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        if (snapshot.val()) {
          callback(snapshot.val());
        }
      });
  }
  static addMessage(room_id, ticket_id, message, callback) {
    console.log("adding message");
    let path = "livechat/" + room_id + "/tickets/" + ticket_id + "/content";
    var newChild = firebase.database().ref(path).push();
    newChild.set(message, callback);
    // firebase
    //   .database()
    //   .ref("livechat/" + room_id)
    //   .update({ unread: child_id });
  }

  // set unread messages to certain user under brand admin role
  static setUnReadMessage(uid, ticket_id, content) {
    console.log("unread", uid, ticket_id, content);
    let ticket = "" + ticket_id;
    let child_id = ticket.split(".").join("");
    let path = "livechat/" + uid + "/unread";
    firebase
      .database()
      .ref(path)
      .update({ [child_id]: content });
  }
  static setTypeValue(room_id, ticket_id, value) {
    let ticket = "" + ticket_id;
    let child_id = ticket.split(".").join("");
    let path = "livechat/" + room_id + "/tickets/" + child_id;
    firebase.database().ref(path).update({ agency_typing: value });
  }
  static requestUserUpgrade(room_id, ticket_id) {
    let ticket = "" + ticket_id;
    let child_id = ticket.split(".").join("");
    let path = "livechat/" + room_id + "/tickets/" + child_id;
    firebase.database().ref(path).update({ requestFullUpgrade: true });
  }
  static getUserTyping(room_id, ticket_id, callback) {
    let ticket = "" + ticket_id;
    let child_id = ticket.split(".").join("");
    let path = "livechat/" + room_id + "/tickets/" + child_id + "/user_typing";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        if (snapshot.val()) callback(snapshot.val());
        else callback(false);
      });
  }
  static getLandlordTyping(room_id, ticket_id, callback) {
    let ticket = "" + ticket_id;
    let child_id = ticket.split(".").join("");
    let path =
      "livechat/" + room_id + "/tickets/" + child_id + "/landlord_typing";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        if (snapshot.val()) callback(snapshot.val());
        else callback(false);
      });
  }
  static getContractorTyping(room_id, ticket_id, callback) {
    let ticket = "" + ticket_id;
    let child_id = ticket.split(".").join("");
    let path =
      "livechat/" + room_id + "/tickets/" + child_id + "/contractor_typing";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        if (snapshot.val()) callback(snapshot.val());
        else callback(false);
      });
  }
  static getAnswerfromTicket(ticket, callback) {
    let sub_path = "chatbot/answers";
    firebase
      .database()
      .ref(sub_path)
      .orderByChild("ticket")
      .equalTo(ticket)
      .once("value", (snapshot) => {
        if (snapshot.val()) {
          let result = [];
          result = Object.values(snapshot.val());
          callback(result[0]);
        } else callback(null);
      });
  }
  static updateTicketPolicy(room_id, ticket_id, policy) {
    let ticket = "" + ticket_id;
    let child_id = ticket.split(".").join("");
    let path = "livechat/" + room_id + "/tickets/" + child_id;
    firebase.database().ref(path).update({ policy: policy });
  }
  static updateTicketNote(room_id, ticket_id, note) {
    let ticket = "" + ticket_id;
    let child_id = ticket.split(".").join("");
    let path = "livechat/" + room_id + "/tickets/" + child_id;
    if (note) firebase.database().ref(path).update({ note: note });
  }
  static async getTicketData(room_id, ticket_id, callback) {
    let ticket = "" + ticket_id;
    let child_id = ticket.split(".").join("");
    let path = "livechat/" + room_id + "/tickets/" + child_id;
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        callback(snapshot.val());
      });
  }
  static async getUserTickets(uid, callback) {
    let path = "livechat/" + uid + "/tickets/";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        callback(snapshot.val());
      });
  }
  static async getTicketDataOnce(room_id, ticket_id) {
    let ticket = "" + ticket_id;
    let child_id = ticket.split(".").join("");
    let path = "livechat/" + room_id + "/tickets/" + child_id;
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(path)
        .once("value", (snapshot) => {
          resolve(snapshot.val());
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  static getBrandDataByName = (brand_name) => {
    let path = "brands";
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(path)
        .orderByChild("name")
        .equalTo(brand_name)
        .on("value", (snapshot) => {
          let result = [];
          result = snapshot.val();
          let res = Object.values(result).find((result) => !result.deactive);
          resolve(res);
        });
    });
  };

  static getBrandDataByPathSegment = async (pathSegment) => {
    pathSegment = pathSegment.replaceAll(" ", "").toLowerCase();

    try {
      const querySnapshot = await firebase
        .database()
        .ref("brands")
        .orderByChild("pathSegment")
        .equalTo(pathSegment)
        .once("value");

      if (!querySnapshot.exists()) return null;

      const queryData = querySnapshot.val();
      const brandData = Object.values(queryData).reduce((acc, cur, i) => {
        if (Object.keys(acc).length) return acc;
        else if (!cur.deactive) {
          acc = { ...cur, id: Number(Object.keys(queryData)[i]) };
        }
        return acc;
      }, {});

      return brandData;
    } catch (e) {
      console.log("getBrandDataByPathSegment error", e);
    }
  };

  static getTicketByBrandID(brand, callback) {
    let path = "brands/" + brand;
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        if (snapshot.val()) {
          let brand_name = snapshot.val().name;
          if (brand_name === "Ecosystem") brand_name = null;
          path = "livechat";
          firebase
            .database()
            .ref(path)
            .orderByChild("brand")
            .equalTo(brand_name)
            .on("value", (snapshot) => {
              callback(snapshot.val());
            });
        }
      });
  }
  static getAllTicketTypes(callback) {
    let path = "ticket_types";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        if (snapshot.val()) {
          firebase
            .database()
            .ref(path)
            .on("value", (snapshot) => {
              callback(snapshot.val());
            });
        }
      });
  }
  static getAllTicketIssues(callback) {
    let path = "chatbot/answers";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        if (snapshot.val()) {
          firebase
            .database()
            .ref(path)
            .on("value", (snapshot) => {
              callback(snapshot.val());
            });
        }
      });
  }
  static acceptRequest(room_id, ticket_id) {
    let ticket = "" + ticket_id;
    let child_id = ticket.split(".").join("");
    let path = "livechat/" + room_id + "/tickets/" + child_id;
    return firebase.database().ref(path).update({ status: "Open" });
  }

  static terminateChat(room_id, ticket_id) {
    let ticket = "" + ticket_id;
    let child_id = ticket.split(".").join("");
    let path = "livechat/" + room_id + "/tickets/" + child_id;
    return firebase
      .database()
      .ref(path)
      .update({ status: "Closed", content: null });
  }
  static submitBrandForReview = async (brandData) => {
    const { brand, ...otherData } = brandData;
    const pendingBrandsRef = firebase.firestore().collection("pending-brands");

    const docSnapshot = await pendingBrandsRef.doc(brand).get();
    if (docSnapshot.exists)
      return { success: false, message: "This brand name already exists." };

    await pendingBrandsRef.doc(brand).set({
      ...otherData,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    });
    return {
      success: true,
      message: "Successfully submitted brand details for review.",
    };
  };
  static findDuplicatePendingBrand = async (brandName) => {
    const docSnapshot = await firebase
      .firestore()
      .collection("pending-brands")
      .doc(brandName)
      .get();
    return docSnapshot.exists;
  };
  static findDuplicatePendingEmail = async (brandEmail) => {
    const querySnapshot = await firebase
      .firestore()
      .collection("pending-brands")
      .where("email", "==", brandEmail)
      .get();
    return querySnapshot.size > 0;
  };
  static getPendingBrands = async () => {
    const snapshot = await firebase
      .firestore()
      .collection("pending-brands")
      .get();
    return snapshot.docs.map((doc) => ({ ...doc.data(), name: doc.id }));
  };

  static deleteFile = async (path) => {
    try {
      const assetRef = firebase.storage().ref(path);
      path && (await assetRef.delete());
      return { success: true };
    } catch (e) {
      console.error("deleteFile() error", e);
      return { success: false };
    }
  };

  static deletePendingBrand = async (brandName) => {
    try {
      await firebase
        .firestore()
        .collection("pending-brands")
        .doc(brandName)
        .delete();
      return { success: true };
    } catch (err) {
      console.log("deletePendingBrand() error", err);
      return { success: false };
    }
  };
  static addBrandUrl(
    brand_name,
    brand_url,
    logo_url,
    icon_url,
    hexcode,
    territory,
    umbrella,
    callback
  ) {
    let path = "brands/";
    firebase
      .database()
      .ref(path)
      .once("value", (snapshot) => {
        let key = snapshot.val().length;

        key.toString();
        path = "brands/" + key;

        firebase
          .database()
          .ref(path)
          .set({
            crmTabs: DEFAULT_CRM_TABS,
            logo: logo_url,
            icon: icon_url,
            name: brand_name,
            url: brand_url,
            hex: hexcode,
            territory: territory,
            umbrella: !!umbrella,
            salesStage: umbrella ? "Full Roll Out" : "",
            services_routing,
            white: false,
            authentication: { interface: "chatbot", method: "email" },
            pathSegment: brand_name.toLowerCase().replaceAll(" ", ""),
            created_at: moment().valueOf(),
            polls: [
              {
                isDemo: true,
                id: shortid.generate(),
                answers: [
                  {
                    icon: "https://firebasestorage.googleapis.com/v0/b/boltconcierge-2f0f9.appspot.com/o/services%2Fstore%2Fletters%2Ficons8-circled-a-100.png?alt=media&token=6604bc85-7d17-4bfa-9726-b90da52bdc6c",
                    text: "Europe",
                  },
                  {
                    icon: "https://firebasestorage.googleapis.com/v0/b/boltconcierge-2f0f9.appspot.com/o/services%2Fstore%2Fletters%2Ficons8-circled-b-100.png?alt=media&token=1716aecc-6d19-4dc2-908e-4e8edd247c13",
                    text: "Asia",
                  },
                  {
                    icon: "https://firebasestorage.googleapis.com/v0/b/boltconcierge-2f0f9.appspot.com/o/services%2Fstore%2Fletters%2Ficons8-circled-c-100.png?alt=media&token=07ded12c-dcbd-4553-a754-b5fddd2a7b25",
                    text: "USA",
                  },
                  {
                    icon: "https://firebasestorage.googleapis.com/v0/b/boltconcierge-2f0f9.appspot.com/o/services%2Fstore%2Fletters%2Ficons8-circled-d-100.png?alt=media&token=6f69df2c-cdd9-457c-8bd3-d61253058f60",
                    text: "Staycation",
                  },
                ],
                closed: true,
                question:
                  "Demo Poll - Where would you like to go on Holiday to next?",
                question_img:
                  "https://firebasestorage.googleapis.com/v0/b/boltconcierge-2f0f9.appspot.com/o/mock_images%2Fdemo_poll2.jpg?alt=media&token=bf960b25-8b09-4c5e-91b4-ca9e7277ce9a",
                created_at: moment().valueOf(),
              },
              {
                isDemo: true,
                id: shortid.generate(),
                answers: [
                  {
                    icon: "https://firebasestorage.googleapis.com/v0/b/boltconcierge-2f0f9.appspot.com/o/services%2Fstore%2Fletters%2Ficons8-circled-a-100.png?alt=media&token=6604bc85-7d17-4bfa-9726-b90da52bdc6c",
                    text: "I love it",
                  },
                  {
                    icon: "https://firebasestorage.googleapis.com/v0/b/boltconcierge-2f0f9.appspot.com/o/services%2Fstore%2Fletters%2Ficons8-circled-b-100.png?alt=media&token=1716aecc-6d19-4dc2-908e-4e8edd247c13",
                    text: "It could be better",
                  },
                  {
                    icon: "https://firebasestorage.googleapis.com/v0/b/boltconcierge-2f0f9.appspot.com/o/services%2Fstore%2Fletters%2Ficons8-circled-c-100.png?alt=media&token=07ded12c-dcbd-4553-a754-b5fddd2a7b25",
                    text: "I don't think I'll use it",
                  },
                  {
                    icon: "https://firebasestorage.googleapis.com/v0/b/boltconcierge-2f0f9.appspot.com/o/services%2Fstore%2Fletters%2Ficons8-circled-d-100.png?alt=media&token=6f69df2c-cdd9-457c-8bd3-d61253058f60",
                    text: "I'll share with friends",
                  },
                ],
                question:
                  "Demo Poll - What do you think of the latest product release?",
                question_img:
                  "https://firebasestorage.googleapis.com/v0/b/boltconcierge-2f0f9.appspot.com/o/mock_images%2Fdemo_poll1.jpg?alt=media&token=98f1a790-a9c2-4a74-954b-b109d2fe7a39",
                created_at: moment().valueOf(),
              },
            ],
          })
          .then(() => {
            callback(key);
          })
          .catch(() => callback("error"));

        this.addCommunityMember(
          {
            avatar_url:
              "https://firebasestorage.googleapis.com/v0/b/boltconcierge-2f0f9.appspot.com/o/mock_images%2Fdemo_account.png?alt=media&token=9eadc1c3-2960-44d1-8690-35ec0aef9410",
            dob: "10/06/1988",
            firstname: "Laura (demo)",
            isDemo: true,
            phonenumber: "temp_phone",
            tokenSpent: 20,
            tokens: 200,
            userstatus: "Pending",
          },
          brand_name
        ).then((user) => {
          if (!user) return;
          Firebase.addPurePost(
            {
              uid: localStorage.getItem("uid"),
              title: "We are excited to launch our community ecosystem",
              content:
                "Welcome to your community, where we reward you for being amazing, helping you to unlock new rewards across all walks of life from Waitrose to Asos, to Nike we’ve got your back. We connect you with other amazing verified members to unlock new value. The platform also helps us learn more about you with polls and content, so we can offer more and more value.",
              image_url:
                "https://firebasestorage.googleapis.com/v0/b/boltconcierge-2f0f9.appspot.com/o/demo_feed.jpg?alt=media&token=497d0286-9207-447c-ba98-b1d30b441ed1",
              media_type: GIF_UPLOAD,
              media_url:
                "https://firebasestorage.googleapis.com/v0/b/boltconcierge-2f0f9.appspot.com/o/hotVideos%2Fgifs%2F1680695401502?alt=media&token=92393a54-2a83-49b1-adea-1e665d1ef17b",
              type: "A milestone",
              topic: "Celebrating",
              accepted: true,
              from_admin: true,
              postNow: true,
            },
            brand_name
          );

          Firebase.addLiveChat(user.id, {
            brand: brand_name,
            tickets: {
              12: {
                adjective: "Cold",
                band: "urgent issue",
                contractor_id: "OBSvq2HxehOudbuyk73bMJsxcSo1",
                contractor_typing: false,
                issue: "Immersion Heater ",
                item: "Shower Water",
                repair_sla: "within 3 working hours",
                response_sla: "within 1 hour",
                room: "Bathroom",
                status: "Open",
                ticket_id: 1.2,
                time: "1594919605967",
                title: "Home Repairs",
                content: {},
              },
            },
            isDemo: true,
            uid: user.id,
            username: "Laura (demo)",
          });
        });
      });
  }
  static uploadImage(content, imagename, folder) {
    let path =
      "/" +
      folder +
      "/" +
      imagename.replace(/[^a-zA-Z]/g, "") +
      new Date().valueOf();
    return new Promise((resolve, reject) => {
      let storageRef = this.storage().ref(path);
      storageRef.putString(content, "base64").then(function (snap) {
        storageRef
          .getDownloadURL()
          .then(function (img_url) {
            resolve(img_url);
          })
          .catch((err) => {
            reject(err);
          });
      });
    });
  }
  /**
   * The uploadFile method is intended to replace all other file upload methods in the future.
   * @param {*} input (Event or File)
   * @param {*} imagename
   * @param {string} folder
   */
  static async uploadFile(input, imagename, folder) {
    let fileBase64 = await getFileBase64(input);
    const fileName = imagename.replace(/[^a-zA-Z]/g, "") + new Date().valueOf();
    const path = `/${folder}/${fileName}`;

    // Extract image type from base64 string
    let contentType;
    if (fileBase64.startsWith("data:image/png")) {
      contentType = "image/png";
    } else if (
      fileBase64.startsWith("data:image/jpeg") ||
      fileBase64.startsWith("data:image/jpg")
    ) {
      contentType = "image/jpeg";
    } else if (fileBase64.startsWith("data:image/gif")) {
      contentType = "image/gif";
    } else if (fileBase64.startsWith("data:image/svg+xml")) {
      contentType = "image/svg+xml";
    } else {
      throw new Error("Unsupported image type");
    }

    fileBase64 = fileBase64
      .replace(/^data\:image\/\w+\;base64\,/, "")
      .replace("data:image/svg+xml;base64,", ""); // needed to remove svg+xml

    return new Promise((resolve, reject) => {
      let storageRef = this.storage().ref(path);
      storageRef
        .putString(fileBase64, "base64", { contentType: contentType })
        .then(function (_snap) {
          storageRef
            .getDownloadURL()
            .then(function (img_url) {
              resolve(img_url);
            })
            .catch((err) => {
              reject(err);
            });
        });
    });
  }
  /**
   * TODO: The above uploadFile method now also supports gifs
   * which renders the uploadGif method redundant. The uploadGif has
   * not been removed yet because it is used across this project.
   * In the future, the uploadGif method should be removed to keep our code DRY.
   * */
  static uploadGif(content, imagename, folder) {
    let path =
      "/" +
      folder +
      "/" +
      imagename.replace(/[^a-zA-Z]/g, "") +
      new Date().valueOf();
    return new Promise((resolve, reject) => {
      let storageRef = this.storage().ref(path);
      storageRef.put(content).then(function (snap) {
        storageRef
          .getDownloadURL()
          .then(function (img_url) {
            resolve(img_url);
          })
          .catch((err) => {
            reject(err);
          });
      });
    });
  }
  static uploadImg(content, imagename, folder) {
    let path =
      "/" +
      folder +
      "/" +
      imagename.replace(/[^a-zA-Z]/g, "") +
      new Date().valueOf();
    return new Promise((resolve, reject) => {
      let storageRef = this.storage().ref(path);
      storageRef.put(content).then(function (snap) {
        storageRef
          .getDownloadURL()
          .then(function (img_url) {
            resolve(img_url);
          })
          .catch((err) => {
            reject(err);
          });
      });
    });
  }
  static uploadPDF(content, pdfname, folder) {
    let path =
      "/" +
      folder +
      "/" +
      pdfname.replace(/[^a-zA-Z]/g, "") +
      new Date().valueOf();
    return new Promise((resolve, reject) => {
      let storageRef = this.storage().ref(path);
      storageRef
        .put(content, { contentType: "application/pdf" })
        .then(function (snap) {
          storageRef
            .getDownloadURL()
            .then(function (pdf_url) {
              resolve(pdf_url);
            })
            .catch((err) => {
              reject(err);
            });
        });
    });
  }
  static uploadVideo(file, folder) {
    const path = `/${folder}/${file.name ? `${file.name}-` : ""}${Date.now()}`;
    const storageRef = this.storage().ref(path);
    return storageRef.put(file, { contentType: file.type ? file.type : null });
  }
  static updateLogoBrand(brand_id, imagename, logo_img) {
    let logostorageRef = this.storage().ref(`/brand_logo/${imagename}`);
    logostorageRef.putString(logo_img, "base64").then(function (snap) {
      logostorageRef.getDownloadURL().then(function (logo_url) {
        Firebase.updateBrandDataById(brand_id, { logo: logo_url });
      });
    });
  }
  static updateIconBrand(brand_id, imagename, icon_img) {
    let logostorageRef = this.storage().ref(`/brand_icon/${imagename}`);
    logostorageRef.putString(icon_img, "base64").then(function (snap) {
      logostorageRef.getDownloadURL().then(function (icon_url) {
        Firebase.updateBrandDataById(brand_id, { icon: icon_url });
      });
    });
  }

  static updateFirstAvatarBrand(brand_id, imagename, icon_img) {
    return new Promise((resolve, reject) => {
      let logostorageRef = this.storage().ref(`/brand_avatar/${imagename}_1`);
      logostorageRef.putString(icon_img, "base64").then(function (snap) {
        logostorageRef.getDownloadURL().then(function (icon_url) {
          Firebase.updateBrandDataById(brand_id, { avatar1: icon_url })
            .then((res) => resolve(res))
            .catch((e) => reject(e));
        });
      });
    });
  }

  static updateSecondAvatarBrand(brand_id, imagename, icon_img) {
    return new Promise((resolve, reject) => {
      let logostorageRef = this.storage().ref(`/brand_avatar/${imagename}_2`);
      logostorageRef.putString(icon_img, "base64").then(function (snap) {
        logostorageRef.getDownloadURL().then(function (icon_url) {
          Firebase.updateBrandDataById(brand_id, { avatar2: icon_url })
            .then((res) => resolve(res))
            .catch((e) => reject(e));
        });
      });
    });
  }

  static addFiletoBrand(
    imagename,
    url,
    logo_img,
    icon_img,
    hexcode,
    territory,
    umbrella,
    callback
  ) {
    let logostorageRef = this.storage().ref(`/brand_logo/${imagename}`);
    let iconstorageRef = this.storage().ref(`/brand_icon/${imagename}`);
    logostorageRef
      .putString(logo_img, "base64")
      .then(function (snap) {
        logostorageRef
          .getDownloadURL()
          .then(function (brand_url) {
            let brandimg_url = brand_url;

            iconstorageRef.putString(icon_img, "base64").then(function (snap) {
              iconstorageRef.getDownloadURL().then(function (icon_url) {
                let iconimg_url = icon_url;
                Firebase.addBrandUrl(
                  imagename,
                  url,
                  brandimg_url,
                  iconimg_url,
                  hexcode,
                  territory,
                  umbrella,
                  (res) => {
                    console.log("brand key:", res);
                    callback(res);
                  }
                );
              });
            });
          })
          .catch(function (error) {
            callback("error");
            console.log(error.message);
          });
      })
      .catch(function (error) {
        callback(error.message);
      });
  }
  static addOfferImage(type, imgname, logo_img, bg_img) {
    let logostorageRef = this.storage().ref(`/offers/${type}/logo/${imgname}`);
    let bgstorageRef = this.storage().ref(
      `/offers/${type}/background/${imgname}`
    );
    return new Promise((resolve, reject) => {
      logostorageRef
        .putString(logo_img, "base64")
        .then(function (snap) {
          logostorageRef
            .getDownloadURL()
            .then(function (logo_url) {
              bgstorageRef.putString(bg_img, "base64").then(function (snap) {
                bgstorageRef
                  .getDownloadURL()
                  .then(function (bg_url) {
                    const res = { logo: logo_url, background: bg_url };
                    resolve(res);
                  })
                  .catch((err) => {
                    reject(err);
                  });
              });
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static addOfferLogo(type, imgname, logo_img) {
    let logostorageRef = this.storage().ref(`/offers/${type}/logo/${imgname}`);
    return new Promise((resolve, reject) => {
      logostorageRef
        .putString(logo_img, "base64")
        .then(function (snap) {
          logostorageRef
            .getDownloadURL()
            .then((logo_url) => {
              resolve(logo_url);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static addOfferBackground(type, imgname, bg_img) {
    let bgstorageRef = this.storage().ref(
      `/offers/${type}/background/${imgname}`
    );
    return new Promise((resolve, reject) => {
      bgstorageRef
        .putString(bg_img, "base64")
        .then(function (snap) {
          bgstorageRef
            .getDownloadURL()
            .then((bg_url) => {
              resolve(bg_url);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static addNCRetailerLogo(retailerName, voucherType, logo) {
    let logostorageRef = this.storage().ref(
      `/retailers/${voucherType}/logo/${retailerName}`
    );

    return new Promise((resolve, reject) => {
      logostorageRef
        .putString(logo, "base64")
        .then(() => {
          logostorageRef
            .getDownloadURL()
            .then((logo_url) => {
              resolve(logo_url);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static addNCRetailerEcopayLogo(retailerName, voucherType, ecopayLogo) {
    let logostorageRef = this.storage().ref(
      `/retailers/${voucherType}/ecopayLogo/${retailerName}`
    );

    return new Promise((resolve, reject) => {
      logostorageRef
        .putString(ecopayLogo, "base64")
        .then(() => {
          logostorageRef
            .getDownloadURL()
            .then((logo_url) => {
              resolve(logo_url);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static addNCRetailerEcopayIcon(retailerName, voucherType, ecopayIcon) {
    let logostorageRef = this.storage().ref(
      `/retailers/${voucherType}/ecopayIcon/${retailerName}`
    );

    return new Promise((resolve, reject) => {
      logostorageRef
        .putString(ecopayIcon, "base64")
        .then(() => {
          logostorageRef
            .getDownloadURL()
            .then((icon_url) => {
              resolve(icon_url);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  static addNCRetailerTransparentLogo(
    retailerName,
    voucherType,
    transparentLogo
  ) {
    let logostorageRef = this.storage().ref(
      `/retailers/${voucherType}/transparentLogo/${retailerName}`
    );

    return new Promise((resolve, reject) => {
      logostorageRef
        .putString(transparentLogo, "base64")
        .then(() => {
          logostorageRef
            .getDownloadURL()
            .then((icon_url) => {
              resolve(icon_url);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  static addNCRetailerBackgroundLogo(retailerName, voucherType, logo) {
    let logostorageRef = this.storage().ref(
      `/nc_retailers/${voucherType}/logo/${retailerName}_background`
    );

    return new Promise((resolve, reject) => {
      logostorageRef
        .putString(logo, "base64")
        .then(() => {
          logostorageRef
            .getDownloadURL()
            .then((logo_url) => {
              resolve(logo_url);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static addRetailerLogo(retailerName, retailerType, logo) {
    let logostorageRef = this.storage().ref(
      `/retailers/${retailerType}/logo/${retailerName}`
    );

    return new Promise((resolve, reject) => {
      logostorageRef
        .putString(logo, "base64")
        .then(() => {
          logostorageRef
            .getDownloadURL()
            .then((logo_url) => {
              resolve(logo_url);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static addRetailerEcopayLogo(retailerName, retailerType, ecopayLogo) {
    let logostorageRef = this.storage().ref(
      `/retailers/${retailerType}/ecopayLogo/${retailerName}`
    );

    return new Promise((resolve, reject) => {
      logostorageRef
        .putString(ecopayLogo, "base64")
        .then(() => {
          logostorageRef
            .getDownloadURL()
            .then((logo_url) => {
              resolve(logo_url);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static addRetailerEcopayIcon(retailerName, retailerType, ecopayIcon) {
    let logostorageRef = this.storage().ref(
      `/retailers/${retailerType}/ecopayIcon/${retailerName}`
    );

    return new Promise((resolve, reject) => {
      logostorageRef
        .putString(ecopayIcon, "base64")
        .then(() => {
          logostorageRef
            .getDownloadURL()
            .then((icon_url) => {
              resolve(icon_url);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static addRetailerTransparentLogo(
    retailerName,
    retailerType,
    transparentLogo
  ) {
    let logostorageRef = this.storage().ref(
      `/retailers/${retailerType}/transparentLogo/${retailerName}`
    );

    return new Promise((resolve, reject) => {
      logostorageRef
        .putString(transparentLogo, "base64")
        .then(() => {
          logostorageRef
            .getDownloadURL()
            .then((icon_url) => {
              resolve(icon_url);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static addRetailerBackgroundLogo(retailerName, retailerType, logo) {
    let logostorageRef = this.storage().ref(
      `/retailers/${retailerType}/logo/${retailerName}_background`
    );

    return new Promise((resolve, reject) => {
      logostorageRef
        .putString(logo, "base64")
        .then(() => {
          logostorageRef
            .getDownloadURL()
            .then((logo_url) => {
              resolve(logo_url);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static addCommunityMember = (profile, brand) => {
    const { phonenumber } = profile;
    return new Promise((resolve, reject) => {
      let fbInstance;
      if (brand !== "Ecosystem") {
        fbInstance = firebase
          .firestore()
          .collection(`${brand}`)
          .doc("data")
          .collection("user");
      } else {
        fbInstance = firebase.firestore().collection(`user`);
      }

      fbInstance
        .where("phonenumber", "==", phonenumber)
        .get()
        .then((snapshot) => {
          if (!snapshot.size) {
            fbInstance
              .add(profile)
              .then((res) => {
                resolve(res);
              })
              .catch((err) => {
                reject(err);
              });
          } else resolve(false);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
  static addLightUser = (brand, user) => {
    return new Promise((resolve, reject) => {
      let fbInstance;
      if (brand !== "Ecosystem") {
        fbInstance = firebase
          .firestore()
          .collection(`${brand}`)
          .doc("data")
          .collection("user");
      } else {
        fbInstance = firebase.firestore().collection(`user`);
      }
      fbInstance
        .add(user)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
  static addUser = (user, brand) => {
    return new Promise((resolve, reject) => {
      if (brand !== "Ecosystem") {
        firebase
          .firestore()
          .collection(`${brand}`)
          .doc("data")
          .collection("user")
          .add(user)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      }
    });
  };
  static addEcosystemUser(user) {
    let firstname = user.firstname || "demo";
    let dob = user.dob || "demo";
    let phonenumber = user.phonenumber ? user.phonenumber : "demo";
    let renter_owner = user.renter_owner || null;
    let new_user = { firstname, dob, phonenumber, renter_owner };
    return firebase.firestore().collection("ecosystem_user").add(new_user);
  }
  static getAllEcoUsers() {
    return new Promise((resolve, reject) => {
      let users = Firebase.firestore()
        .collection("ecosystem_user")
        .get()
        .then((snapshot) => {
          return snapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));
        });
      resolve(users);
    });
  }
  static updateCommunityMember = (profile, brand) => {
    const { phonenumber } = profile;
    return new Promise((resolve, reject) => {
      let fbInstance;
      if (brand !== "Ecosystem") {
        fbInstance = firebase
          .firestore()
          .collection(`${brand}`)
          .doc("data")
          .collection("user");
      } else {
        fbInstance = firebase.firestore().collection(`user`);
      }

      fbInstance
        .where("phonenumber", "==", phonenumber)
        .get()
        .then((snapshot) => {
          if (snapshot.size) {
            let val = snapshot.docs[0];
            fbInstance
              .doc(val.id)
              .set(profile, { merge: true })
              .then(() => {
                resolve();
              })
              .catch((err) => {
                reject(err);
              });
          } else resolve(false);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  static removeCommunityMember = (id, brand) => {
    return new Promise((resolve, reject) => {
      let fbInstance;
      if (brand !== "Ecosystem") {
        fbInstance = firebase
          .firestore()
          .collection(`${brand}`)
          .doc("data")
          .collection("user");
      } else {
        fbInstance = firebase.firestore().collection(`user`);
      }
      fbInstance
        .doc(id)
        .delete()
        .then(() => {
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  static deleteUser = (brand_name, uid, collectionPath) => {
    let fbInstance;
    if (brand_name !== "Ecosystem") {
      fbInstance = firebase
        .firestore()
        .collection(`${brand_name}`)
        .doc("data")
        .collection("user")
        .doc(uid);
    } else {
      fbInstance = firebase.firestore().collection(`user`).doc(uid);
    }
    const collectionRef = fbInstance.collection(collectionPath);
    const query = collectionRef.limit(1000);
    return new Promise((resolve, reject) => {
      deleteQueryBatch(firebase.firestore(), query, resolve).catch(reject);
    });
  };

  static addLiveChat = (id, chat) => {
    let path = "livechat/" + id;
    return firebase.database().ref(path).set(chat);
  };
  static removeLiveChat = (chatId) => {
    let path = "livechat/" + chatId;
    return firebase.database().ref(path).remove();
  };

  static createDefaultBrandAdmin = (id, brand) => {
    const email = `${brand
      .trim()
      .replace(/ /g, "_")}@ecosystem.club`.toLowerCase();
    Firebase.addAgency(email, "Ecosystem2020")
      .then((uid) => {
        Firebase.writeAgencydata(uid, {
          uid: uid,
          username: brand.trim(),
          email: email,
          role: 2,
          brand: id,
          approved: true,
        });
      })
      .catch((err) => {
        console.log("createDefaultBrandAdmin", brand, err);
      });
  };

  static getTokenSpentHistory = (brand_name, uid, callback) => {
    let fbInstance;
    if (brand_name === "Ecosystem") {
      fbInstance = firebase.firestore().collection("user");
    } else {
      fbInstance = firebase
        .firestore()
        .collection(brand_name)
        .doc("data")
        .collection("user");
    }

    fbInstance
      .doc(`${uid}`)
      .collection("token_history")
      .onSnapshot((res) => {
        callback(res.docs.map((obj) => obj.data()));
      });
  };

  static getTokenSpentHistoryPromise = (brand_name, uid) => {
    let fbInstance;
    if (brand_name === "Ecosystem") {
      fbInstance = firebase.firestore().collection("user");
    } else {
      fbInstance = firebase
        .firestore()
        .collection(brand_name)
        .doc("data")
        .collection("user");
    }
    return new Promise((resolve, reject) => {
      fbInstance
        .doc(`${uid}`)
        .collection("token_history")
        .onSnapshot((res) => {
          if (res) {
            const history = res.docs.map((obj) => obj.data());
            resolve(history);
          } else resolve([]);
        });
    });
  };

  static getEcoUserbyId(eco_id) {
    return new Promise((resolve, reject) => {
      return firebase
        .firestore()
        .collection("ecosystem_user")
        .doc(eco_id)
        .get()
        .then((res) => {
          resolve(res.data());
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  static async getReviews(brandname, callback) {
    return firebase
      .firestore()
      .collection(brandname)
      .doc("data")
      .collection("review")
      .orderBy("createdAt")
      .onSnapshot((snapshot) => {
        let reviews = [];
        if (snapshot.size) {
          snapshot.forEach((doc) => {
            reviews.push({ id: doc.id, ...doc.data() });
          });
        }
        callback(reviews);
      });
  }

  static async getRepManagerReviews(brandname, callback) {
    return firebase
      .firestore()
      .collection(brandname)
      .doc("data")
      .collection("rep_manager_review")
      .orderBy("createdAt")
      .onSnapshot((snapshot) => {
        let reviews = [];
        if (snapshot.size) {
          snapshot.forEach((doc) => {
            reviews.push({ id: doc.id, ...doc.data() });
          });
        }
        callback(reviews);
      });
  }

  static async getPremierTokens(brand_name, uid) {
    let fbInstance;
    if (brand_name === "Ecosystem") {
      fbInstance = firebase.firestore().collection("user");
    } else {
      fbInstance = firebase
        .firestore()
        .collection(brand_name)
        .doc("data")
        .collection("user");
    }
    return new Promise((resolve, reject) => {
      fbInstance
        .doc(`${uid}`)
        .collection("premier_token_history")
        .onSnapshot((res) => {
          let premier_tokens = 0;
          if (res) {
            res.docs.map((obj) => {
              let data = obj.data();
              if (data.environment === "production")
                premier_tokens -= data.amount;
            });
            resolve(premier_tokens);
          } else {
            resolve(0);
          }
        });
    });
  }
  static async getPremierTokensHistory(brand_name, uid) {
    let fbInstance;
    if (brand_name === "Ecosystem") {
      fbInstance = firebase.firestore().collection("user");
    } else {
      fbInstance = firebase
        .firestore()
        .collection(brand_name)
        .doc("data")
        .collection("user");
    }
    return new Promise((resolve, reject) => {
      fbInstance
        .doc(`${uid}`)
        .collection("premier_token_history")
        .onSnapshot((res) => {
          if (res) {
            const history = res.docs
              .map((obj) => {
                let data = obj.data();
                if (data.environment === "production") return data;
              })
              .filter((data) => data);
            resolve(history);
          } else {
            resolve(0);
          }
        });
    });
  }
  static savePremierTokenHistory = (brand_name, uid, data) => {
    return new Promise((resolve, reject) => {
      let fbInstance;
      if (brand_name === "Ecosystem") {
        fbInstance = firebase.firestore().collection("user");
      } else {
        fbInstance = firebase
          .firestore()
          .collection(brand_name)
          .doc("data")
          .collection("user");
      }

      fbInstance
        .doc(`${uid}`)
        .collection("premier_token_history")
        .add(data)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  static getUserDatafromPhoneNumber = (brand_name, phoneNumber) => {
    return new Promise((resolve, reject) => {
      let fbInstance;
      if (brand_name === "Ecosystem") {
        fbInstance = firebase.firestore().collection("user");
      } else {
        fbInstance = firebase
          .firestore()
          .collection(brand_name)
          .doc("data")
          .collection("user");
      }

      fbInstance
        .where("phonenumber", "==", phoneNumber)
        .get()
        .then((snapshot) => {
          if (!snapshot.size) {
            resolve(null);
          } else {
            const id = snapshot.docs[0].id;
            fbInstance
              .doc(id)
              .get()
              .then((res) => {
                resolve({ id, data: res.data() });
              })
              .catch((err) => {
                reject(err);
              });
          }
          // res.set({ order, value });
        })
        .catch((e) => {
          reject(e);
        });
    });
  };
  static getUserDatafromUID = (brand_name, uid) => {
    if (brand_name !== "Ecosystem") {
      return new Promise((resolve, reject) => {
        firebase
          .firestore()
          .collection(brand_name)
          .doc("data")
          .collection("user")
          .doc(`${uid}`)
          .get()
          .then((res) => {
            resolve(res.data());
          })
          .catch((err) => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        firebase
          .firestore()
          .collection("user")
          .doc(`${uid}`)
          .get()
          .then((res) => {
            resolve(res.data());
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  };
  static updateEvent = (brand_name, event_id, data) => {
    return new Promise((resolve, reject) => {
      let fbInstance;
      if (brand_name === "Ecosystem") {
        fbInstance = firebase.firestore().collection("event");
      } else {
        fbInstance = firebase
          .firestore()
          .collection(brand_name)
          .doc("data")
          .collection("event");
      }

      fbInstance
        .doc(`${event_id}`)
        .set(data, { merge: true })
        .then((res) => {
          resolve(true);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  static deleteEvent(brand_name, event_id) {
    if (brand_name === "EcosystemDemo") {
      Firebase.firestore().collection("event").doc(event_id).delete();
    } else {
      Firebase.firestore()
        .collection(brand_name)
        .doc("data")
        .collection("event")
        .doc(event_id)
        .delete();
    }
  }

  static updateCause = (brand_name, cause_id, data) => {
    return new Promise((resolve, reject) => {
      let fbInstance;
      if (brand_name === "Ecosystem") {
        fbInstance = firebase.firestore().collection("cause");
      } else {
        fbInstance = firebase
          .firestore()
          .collection(brand_name)
          .doc("data")
          .collection("cause");
      }

      fbInstance
        .doc(`${cause_id}`)
        .set(data, { merge: true })
        .then((res) => {
          resolve(true);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  static getAllHotTasks = (brand_name, callback) => {
    let fbInstance;
    if (brand_name === "Ecosystem") {
      fbInstance = firebase.firestore().collection("hot_tasks");
    } else {
      fbInstance = firebase
        .firestore()
        .collection(brand_name)
        .doc("data")
        .collection("hot_tasks");
    }
    fbInstance.doc("data").onSnapshot(
      (res) => {
        callback(res.data() ? res.data().hot_tasks : []);
      },
      (error) => {
        callback(error);
      }
    );
  };
  static removeIncrementalTasks = (brand_name, user_type, order) => {
    return new Promise((resolve, reject) => {
      let fbInstance;
      if (brand_name === "Ecosystem") {
        fbInstance = firebase.firestore().collection("incrementalTasks");
      } else {
        fbInstance = firebase
          .firestore()
          .collection(brand_name)
          .doc("data")
          .collection("incrementalTasks");
      }
      fbInstance
        .where("user_type", "==", user_type)
        .where("order", "==", order)
        .get()
        .then((snapshot) => {
          if (!snapshot.size) {
            return;
          }
          const id = snapshot.docs[0].id;
          fbInstance
            .doc(id)
            .delete()
            .then((res) => resolve(res))
            .catch((e) => reject(e));
        });
    });
  };
  static getIncrementalTasks = (brand_name) => {
    return new Promise((resolve, reject) => {
      let fbInstance;
      if (brand_name === "Ecosystem") {
        fbInstance = firebase.firestore().collection("incrementalTasks");
      } else {
        fbInstance = firebase
          .firestore()
          .collection(brand_name)
          .doc("data")
          .collection("incrementalTasks");
      }
      fbInstance
        .get()
        .then((res) => {
          resolve(res.docs.map((doc) => ({ ...doc.data() })));
        })
        .catch((e) => reject(e));
    });
  };
  static getEarningTaskById = (task_id) => {
    return new Promise((resolve, reject) => {
      let fbInstance;
      fbInstance = firebase
        .firestore()
        .collection("token_earning")
        .doc(task_id)
        .get()
        .then((res) => {
          resolve(res.data());
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  static updateIncrementalTask = (brand_name, value, order) => {
    return new Promise((resolve, reject) => {
      let fbInstance;
      console.log("event:", brand_name);
      if (brand_name === "Ecosystem") {
        fbInstance = firebase.firestore().collection("incrementalTasks");
      } else {
        fbInstance = firebase
          .firestore()
          .collection(brand_name)
          .doc("data")
          .collection("incrementalTasks");
      }
      fbInstance
        .where("user_type", "==", value.user_type)
        .where("order", "==", order)
        .get()
        .then((snapshot) => {
          if (snapshot.size) {
            const id = snapshot.docs[0].id;
            fbInstance.doc(id).set(value);
          } else {
            fbInstance
              .add(value)
              .then((res) => resolve({ task_id: res.id, ...value }))
              .catch((e) => reject(e));
          }
        })
        .catch((e) => reject(e));
      // if (id)
      //   fbInstance
      //     .doc(id)
      //     .set(value)
      //     .then((res) => resolve(res))
      //     .catch((e) => reject(e));
    });
  };
  static updateChecklistEntry = (
    brand_name,
    category,
    order,
    value,
    neworder
  ) => {
    return new Promise((resolve, reject) => {
      let fbInstance;
      console.log("event:", brand_name);
      if (brand_name === "Ecosystem") {
        fbInstance = firebase
          .firestore()
          .collection("checklist")
          .doc("data")
          .collection(category);
      } else {
        fbInstance = firebase
          .firestore()
          .collection(brand_name)
          .doc("data")
          .collection("checklist")
          .doc("data")
          .collection(category);
      }
      fbInstance
        .where("order", "==", order)
        .get()
        .then((snapshot) => {
          if (!snapshot.size) {
            fbInstance
              .add({ order: order, value })
              .then((res) => {
                resolve(res);
              })
              .catch((err) => {
                console.log("🚀 ~  ~ err:", err);
                reject(err);
              });
          } else {
            const id = snapshot.docs[0].id;
            fbInstance.doc(id).set({ order: neworder, value });
          }
        })
        .catch((e) => {
          reject(e);
        });
    });
  };
  static updateLiveTask = (brand_name, order, id) => {
    return new Promise((resolve, reject) => {
      let fbInstance;
      if (brand_name === "Ecosystem") {
        fbInstance = firebase.firestore().collection("hot_tasks");
      } else {
        fbInstance = firebase
          .firestore()
          .collection(brand_name)
          .doc("data")
          .collection("hot_tasks");
      }
      fbInstance
        .doc("data")
        .get()
        .then((res) => {
          if (res.data()) {
            let { hot_tasks } = res.data();
            hot_tasks[order - 1] = id;
            fbInstance.doc("data").set({ hot_tasks });
            resolve(true);
          } else {
            let hot_tasks = ["", "", "", "", "", "", "", "", "", ""];
            hot_tasks[order - 1] = id;
            fbInstance.doc("data").set({ hot_tasks });
            resolve(true);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  static registerSchedule(schedule_data) {
    return firebase
      .firestore()
      .collection("scheduled_contents")
      .add(schedule_data);
  }
  static removeSchedule(schedule_id) {
    return firebase
      .firestore()
      .collection("scheduled_contents")
      .where("id", "==", schedule_id)
      .get()
      .then((snapshot) => {
        if (snapshot.size) {
          let val = snapshot.docs[0];
          firebase
            .firestore()
            .collection("scheduled_contents")
            .doc(val.id)
            .delete();
        }
      });
  }
  static createAdminSupport(brand, data) {
    let path = "admin_support/" + brand;
    let newChild = firebase.database().ref(path).push();
    newChild.set(data);
    const ticket_id = newChild.key;
    const latest = "New Support ticket has been created";
    Firebase.setBrandSupportUnReadMessage(brand, ticket_id, {
      latest,
      time: Date.now(),
      ticket: { ...data, id: ticket_id },
    });
    return ticket_id;
  }
  static getAdminSupport(brand, callback) {
    let path = "admin_support/" + brand;
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        if (snapshot.val()) {
          callback(snapshot.val());
        } else callback(null);
      });
  }
  static getAdminSupportById(brand_id) {
    let path = "admin_support/" + brand_id;
    return new Promise((resolve, _reject) => {
      firebase
        .database()
        .ref(path)
        .on("value", (snapshot) => {
          if (snapshot.val()) {
            resolve(snapshot.val());
          } else resolve(null);
        });
    });
  }
  static getAllAdminSupport(callback) {
    let path = "admin_support/";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        if (snapshot.val()) {
          callback(snapshot.val());
        } else callback(null);
      });
  }
  static updateAdminTicketNotes = (brandId, ticketId, notes) => {
    try {
      const path = `admin_support/${brandId}/${ticketId}`;
      firebase.database().ref(path).update({ notes: notes });
    } catch (err) {
      console.log("updateAdminTicketNotes error", err);
    }
  };
  static addMessageToAdminSupport(brandId, ticketId, message) {
    const path = `admin_support/${brandId}/${ticketId}/content`;
    firebase.database().ref(path).push(message);
  }
  static addTask(task) {
    return firebase.firestore().collection("tasks").add(task);
  }
  static getAllTasksRunningByBrand(brand, callback) {
    Firebase.firestore()
      .collection("tasks")
      .where("brand", "==", brand)
      .onSnapshot((docSnapshot) => {
        const tasks = [];
        docSnapshot.forEach((doc) => {
          tasks.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        callback(tasks);
      });
  }
  //get all unread messages received from users under certain brand admin role
  static getUnReadMessages(brand, callback) {
    Firebase.firestore()
      .collection(brand)
      .doc("data")
      .collection("unreads")
      .onSnapshot((docSnapshot) => {
        const unreads = [];
        docSnapshot.forEach((doc) => {
          unreads.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        callback(unreads);
      });
  }
  //remove unread messages received from user under certain brand admin role
  static readUnReadMessages(brand, id) {
    Firebase.firestore()
      .collection(brand)
      .doc("data")
      .collection("unreads")
      .doc(id)
      .delete();
  }
  //get all unread messages received from brands under super brand role
  static getAllUnReadMessagesSentFromAdmins(callback) {
    let path = "admin_support_unreads/super_admin_unreads";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        if (snapshot.val()) {
          callback(snapshot.val());
        } else callback([]);
      });
  }
  // set unread message to super admin interms of admin support
  static setBrandSupportUnReadMessage(brand_id, ticket_id, data) {
    let path =
      "admin_support_unreads/super_admin_unreads/" + brand_id + "/" + ticket_id;
    firebase
      .database()
      .ref(path)
      .update({ ...data });
  }

  //remove unread messages received from brand under super admin role
  static readBrandSupportUnReadMessage(brand_id, ticket_id) {
    let path =
      "admin_support_unreads/super_admin_unreads/" + brand_id + "/" + ticket_id;
    firebase.database().ref(path).remove();
  }

  //set unread message to brand received from super admin
  static setBrandUnReadMessage(brand_id, ticket_id, data) {
    let path =
      "admin_support_unreads/brand_admin_unreads/" + brand_id + "/" + ticket_id;
    firebase
      .database()
      .ref(path)
      .update({ ...data });
  }

  //get All unread messages from super admin under brand admin role
  static getBrandUnReadMessages(brand_id, callback) {
    let path = "admin_support_unreads/brand_admin_unreads/" + brand_id;
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        if (snapshot.val()) {
          callback(snapshot.val());
        } else callback([]);
      });
  }

  //remove unread messages received from super under brand admin role
  static readBrandUnReadMessage(brand_id, ticket_id) {
    let path =
      "admin_support_unreads/brand_admin_unreads/" + brand_id + "/" + ticket_id;
    firebase.database().ref(path).remove();
  }

  static getGoalsByBrand(brandName, callback) {
    Firebase.firestore()
      .collection(brandName)
      .doc("data")
      .collection("goal")
      .onSnapshot((docSnapshot) => {
        const goals = [];
        docSnapshot.forEach((doc) => {
          goals.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        callback(goals);
      });
  }
  static getConciergeBotsByBrand(brandName, callback) {
    Firebase.firestore()
      .collection(brandName)
      .doc("data")
      .collection("concierge_bot")
      .onSnapshot((docSnapshot) => {
        const concierges = [];
        docSnapshot.forEach((doc) => {
          concierges.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        callback(concierges);
      });
  }
  static getChecklist = (brand_name, category) => {
    return new Promise((resolve, reject) => {
      let fbInstance;
      if (brand_name === "Ecosystem") {
        fbInstance = firebase
          .firestore()
          .collection("checklist")
          .doc("data")
          .collection(category);
      } else {
        fbInstance = firebase
          .firestore()
          .collection(brand_name)
          .doc("data")
          .collection("checklist")
          .doc("data")
          .collection(category);
      }
      fbInstance
        .get()
        .then((res) => {
          resolve(res.docs.map((doc) => doc.data()));
        })
        .catch((e) => reject(e));
    });
  };
  static getArticlesByBrand(brandName, callback) {
    Firebase.firestore()
      .collection(brandName)
      .doc("data")
      .collection("articles")
      .orderBy("time")
      .onSnapshot((docSnapshot) => {
        const articles = [];
        docSnapshot.forEach((doc) => {
          articles.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        callback(articles);
      });
  }
  static getArticlesByBrandPromise(brandName) {
    return new Promise((resolve, reject) => {
      Firebase.firestore()
        .collection(brandName)
        .doc("data")
        .collection("articles")
        .orderBy("time")
        .onSnapshot((docSnapshot) => {
          const articles = [];
          docSnapshot.forEach((doc) => {
            articles.push({
              id: doc.id,
              ...doc.data(),
            });
          });
          resolve(articles);
        });
    });
  }
  static getArticle(brandName, id) {
    return new Promise((resolve, reject) => {
      Firebase.firestore()
        .collection(brandName)
        .doc("data")
        .collection("articles")
        .doc(id)
        .get()
        .then((res) => {
          resolve(res.data());
        });
    });
  }
  static getSuperContents(callback) {
    let path = "super_contents/";
    firebase
      .database()
      .ref(path)
      .on("value", (snapshot) => {
        if (snapshot.val()) {
          callback(snapshot.val());
        } else callback(null);
      });
  }
  static addSuperFeed(feed) {
    let path = "super_contents/feed/";
    var newChild = firebase.database().ref(path).push();
    newChild.set(feed);
    return newChild.id;
  }
  /* daily content functions */
  static addDailyTopic(topic, brand_name) {
    return firebase
      .firestore()
      .collection(brand_name)
      .doc("daily_contents")
      .collection("topic")
      .add(topic);
  }
  static addDailyPerk(perk, brand_name) {
    return firebase
      .firestore()
      .collection(brand_name)
      .doc("daily_contents")
      .collection("perk")
      .add(perk);
  }
  static addDailyTask(task, brand_name) {
    return firebase
      .firestore()
      .collection(brand_name)
      .doc("daily_contents")
      .collection("task")
      .add(task);
  }
  static addDailyVideo(video, brand_name) {
    return firebase
      .firestore()
      .collection(brand_name)
      .doc("daily_contents")
      .collection("video")
      .add(video);
  }
  static addDailyEvent(event, brand_name) {
    return firebase
      .firestore()
      .collection(brand_name)
      .doc("daily_contents")
      .collection("event")
      .add(event);
  }
  static getAllDailyTopics(brand_name, callback) {
    Firebase.firestore()
      .collection(brand_name)
      .doc("daily_contents")
      .collection("topic")
      .onSnapshot((docSnapshot) => {
        const topics = [];
        docSnapshot.forEach((doc) => {
          topics.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        callback(topics);
      });
  }
  static getAllDailyPerks(brand_name, callback) {
    Firebase.firestore()
      .collection(brand_name)
      .doc("daily_contents")
      .collection("perk")
      .onSnapshot((docSnapshot) => {
        const perks = [];
        docSnapshot.forEach((doc) => {
          perks.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        callback(perks);
      });
  }
  static getAllDailyTasks(brand_name, callback) {
    Firebase.firestore()
      .collection(brand_name)
      .doc("daily_contents")
      .collection("task")
      .onSnapshot((docSnapshot) => {
        const tasks = [];
        docSnapshot.forEach((doc) => {
          tasks.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        callback(tasks);
      });
  }
  static getAllDailyVideos(brand_name, callback) {
    Firebase.firestore()
      .collection(brand_name)
      .doc("daily_contents")
      .collection("video")
      .onSnapshot((docSnapshot) => {
        const videos = [];
        docSnapshot.forEach((doc) => {
          videos.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        callback(videos);
      });
  }
  static getAllDailyEvents(brand_name, callback) {
    Firebase.firestore()
      .collection(brand_name)
      .doc("daily_contents")
      .collection("event")
      .onSnapshot((docSnapshot) => {
        const events = [];
        docSnapshot.forEach((doc) => {
          events.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        callback(events);
      });
  }
  static getAllSectors() {
    let path = "sectors";
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(path)
        .on("value", (snapshot) => {
          if (snapshot.val()) {
            resolve(snapshot.val());
          } else resolve([]);
        });
    });
  }
  static getSuperQuestions() {
    let path = "bot_questions";
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(path)
        .on("value", (snapshot) => {
          if (snapshot.val()) {
            resolve(snapshot.val());
          } else resolve([]);
        });
    });
  }
  static getSuperDevelopers(callback) {
    let path = "agencies";
    firebase
      .database()
      .ref(path)
      .orderByChild("role")
      .equalTo(20)
      .on("value", (snapshot) => {
        let res = [];
        let result = [];
        if (snapshot.val()) res = Object.values(snapshot.val());
        res.forEach((item) => {
          if (item.isSuper) result.push(item);
        });
        callback(result);
      });
  }
  static getUsersOnSearch = (brand_name, query) => {
    return new Promise((resolve, reject) => {
      let userRef;
      if (brand_name === "Ecosystem") {
        userRef = firebase.firestore().collection("user");
      } else {
        userRef = firebase
          .firestore()
          .collection(brand_name)
          .doc("data")
          .collection("user");
      }

      // 1. try to search for ecosystem UID (Firestore document id)
      userRef
        .doc(query)
        .get()
        .then((res) => {
          if (res.exists) resolve([{ id: res.id, ...res.data() }]);
          else {
            // 2. try to search for phone number
            userRef
              .where("phonenumber", "==", query)
              .get()
              .then((querySnapshot) => {
                // FIXME: assumption is there is currently more than 1 account with the same phone number
                let results = [];
                querySnapshot.forEach((doc) => {
                  results.push({ id: doc.id, ...doc.data() });
                });
                if (results.length > 0) resolve(results);
                else {
                  // 3. try to search for internal_id (the brand's internally generated ID - not created by us)
                  userRef
                    .where("internal_id", "==", query)
                    .get()
                    .then((querySnapshot) => {
                      // FIXME: assumption is there is currently more than 1 account with the same internal_id
                      let results = [];
                      querySnapshot.forEach((doc) => {
                        results.push({ id: doc.id, ...doc.data() });
                      });
                      if (results.length > 0) resolve(results);
                      else {
                        // 4. if nothing was found return an empty array
                        resolve([]);
                      }
                    })
                    .catch((e) => {
                      console.log("search for internal_id error", e);
                      reject(e);
                    });
                }
              })
              .catch((e) => {
                console.log("search for phonenumber error", e);
                reject(e);
              });
          }
        })
        .catch((e) => {
          console.log("search for UID error", e);
          reject(e);
        });
    });
  };
  static updateSuperTicketType = async (brandId, ticketId, newTicketType) => {
    const path = `admin_support/${brandId}/${ticketId}`;
    firebase.database().ref(path).update({ type: newTicketType });
  };
  static deleteTokenEntry = async (brandName, uid, tokenEntry) => {
    const tokenHistoryName =
      tokenEntry.tokenType === "shopping"
        ? "token_history"
        : "premier_token_history";

    try {
      const userRef = firebase
        .firestore()
        .collection(brandName)
        .doc("data")
        .collection("user")
        .doc(uid);

      // 1. identify token history entry
      const tokenHistoryQuerySnapshot = await userRef
        .collection(tokenHistoryName)
        .where("created", "==", tokenEntry.created)
        .where("type", "==", tokenEntry.type)
        .where("amount", "==", tokenEntry.amount)
        .get();

      if (!tokenHistoryQuerySnapshot.empty) {
        const foundEntry = tokenHistoryQuerySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))[0];

        // 2. delete token history via doc Id
        await userRef.collection(tokenHistoryName).doc(foundEntry.id).delete();
      }

      // 3. check if there is a "histories" entry linked to the token entry
      const historiesQuerySnapshot = await userRef
        .collection("histories")
        .where("created", "==", tokenEntry.created)
        .get();

      if (!historiesQuerySnapshot.empty) {
        const foundEntries = tokenHistoryQuerySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const entryToDelete = foundEntries.filter(
          (entry) => entry.type.toLowerCase() === tokenEntry.type.toLowerCase()
        );
        if (entryToDelete) {
          // 4. delete histories entry doc id
          await userRef.collection("histories").doc(entryToDelete.id).delete();
        }
      }
    } catch (e) {
      console.error("deleteTokenEntry", e);
    }
  };

  static async addBrandPortfolioById(brandId, portfolioData) {
    const path = `brands/${brandId}/portfolios`;
    const ref = firebase.database().ref(path);

    const newPortfolioRef = ref.push();
    const newPortfolioId = newPortfolioRef.key;
    portfolioData.id = newPortfolioId;

    await newPortfolioRef.set(portfolioData);
  }

  static async updateBrandPortfolioById(brandId, portfolioData) {
    const path = `brands/${brandId}/portfolios/${portfolioData.id}`;
    await firebase.database().ref(path).update(portfolioData);
  }

  static async deleteBrandPortfolioById(brandId, portfolioId) {
    const path = `brands/${brandId}/portfolios/${portfolioId}`;
    await firebase.database().ref(path).remove();
  }
}
Firebase.initialize();
export default Firebase;



// WEBPACK FOOTER //
// ./src/firebasehelper/index.js